import { useState, useRef, useEffect, useCallback } from "react";
import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://bdfqpwhdzfamjqbideco.supabase.co";
const SUPABASE_KEY = "sb_publishable_acIZF57vROQ0EsPm1eoI5w_N58IxZLY";
const sb = createClient(SUPABASE_URL, SUPABASE_KEY);

const TAXAS = { CNPJ: 0.015, CPF: 0.02 };
const MESES = ["JANEIRO","FEVEREIRO","MARÇO","ABRIL","MAIO","JUNHO","JULHO","AGOSTO","SETEMBRO","OUTUBRO","NOVEMBRO","DEZEMBRO"];

const fmtMoeda = v => (isNaN(+v)||v===""||v==null)?"":Number(v).toLocaleString("pt-BR",{style:"currency",currency:"BRL"});
const hoje     = () => new Date().toLocaleDateString("pt-BR");
const mesHoje  = () => MESES[new Date().getMonth()];
const horaHoje = () => new Date().toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"});
const addDias  = n  => { const d=new Date(); d.setDate(d.getDate()+parseInt(n||0)); return d.toLocaleDateString("pt-BR",{day:"2-digit",month:"short"}); };
const uid      = () => Date.now()+Math.random();

const linhaVazia = () => ({ nome:"", qtde:"", cxBase:0, cx:"", vlUnit:"", total:0 });
const formVazio  = () => ({
  _localId: uid(), pedido:"", nf:"", data:hoje(), mes:mesHoje(), hora:horaHoje(),
  cliente:"", endereco:"", cidade:"", uf:"", fone:"", cnpj:"", ie:"", classe:"",
  linhas: Array.from({length:5}, linhaVazia),
  emiteNfe:false, tipoPgto:"", qtdeBol:"",
  boletos:[{dias:""},{dias:""},{dias:""}],
});

// ════════════════════════════════════════════════════════════════
// TELA DE LOGIN
// ════════════════════════════════════════════════════════════════
function TelaLogin({ onLogin }) {
  const [email,    setEmail]    = useState("");
  const [senha,    setSenha]    = useState("");
  const [erro,     setErro]     = useState("");
  const [loading,  setLoading]  = useState(false);
  const [mostrarS, setMostrarS] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email.trim() || !senha.trim()) { setErro("Preencha e-mail e senha."); return; }
    setErro(""); setLoading(true);
    try {
      const { data, error } = await sb.auth.signInWithPassword({ email: email.trim(), password: senha });
      if (error) {
        if (error.message.includes("Invalid login")) setErro("E-mail ou senha incorretos.");
        else if (error.message.includes("Email not confirmed")) setErro("E-mail ainda não confirmado.");
        else setErro("Erro ao entrar. Tente novamente.");
      } else if (data?.user) {
        onLogin(data.user);
      }
    } catch {
      setErro("Erro de conexão. Verifique sua internet.");
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight:"100vh", background:"#080f1c",
      display:"flex", alignItems:"center", justifyContent:"center",
      fontFamily:"'DM Sans',system-ui,sans-serif", padding:16,
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&family=DM+Mono:wght@400;500&display=swap');
        *{box-sizing:border-box;margin:0;padding:0;}
        @keyframes fadeUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:none}}
        .fade-login{animation:fadeUp .35s ease;}
        @keyframes spin{to{transform:rotate(360deg)}}
        .spin{animation:spin 1s linear infinite;display:inline-block;}
        .inp-login{
          width:100%;background:#1a2840;border:1px solid #1e3a5f;border-radius:9px;
          padding:11px 14px;color:#e2e8f0;font-size:14px;outline:none;
          transition:border .15s, box-shadow .15s;font-family:inherit;
        }
        .inp-login:focus{border-color:#10b981;box-shadow:0 0 0 3px rgba(16,185,129,.12);}
        .btn-login{
          width:100%;padding:12px;border-radius:9px;border:none;
          background:linear-gradient(135deg,#059669,#10b981);
          color:#fff;font-weight:700;font-size:15px;cursor:pointer;
          transition:opacity .15s, transform .1s;font-family:inherit;
          box-shadow:0 4px 18px rgba(16,185,129,.35);
        }
        .btn-login:hover:not(:disabled){opacity:.9;transform:translateY(-1px);}
        .btn-login:active{transform:translateY(0);}
        .btn-login:disabled{opacity:.6;cursor:not-allowed;}
      `}</style>

      <div className="fade-login" style={{width:"100%", maxWidth:400}}>
        {/* Logo */}
        <div style={{textAlign:"center", marginBottom:32}}>
          <div style={{
            width:64, height:64, borderRadius:18,
            background:"linear-gradient(135deg,#059669,#34d399)",
            display:"inline-flex", alignItems:"center", justifyContent:"center",
            fontSize:30, marginBottom:14,
            boxShadow:"0 8px 32px rgba(16,185,129,.3)"
          }}>🌿</div>
          <div style={{fontSize:26, fontWeight:900, color:"#f1f5f9", letterSpacing:"-0.5px"}}>AUTOPED</div>
          <div style={{fontSize:11, color:"#334155", letterSpacing:"3px", textTransform:"uppercase", marginTop:3}}>Granja Cavazzini</div>
        </div>

        {/* Card */}
        <div style={{
          background:"#0d1526",
          border:"1px solid rgba(52,211,153,.12)",
          borderRadius:16, padding:28,
          boxShadow:"0 20px 60px rgba(0,0,0,.5)"
        }}>
          <div style={{fontSize:15, fontWeight:700, color:"#f1f5f9", marginBottom:6}}>Entrar no sistema</div>
          <div style={{fontSize:12, color:"#334155", marginBottom:22}}>Use suas credenciais de acesso</div>

          <form onSubmit={handleLogin} style={{display:"flex", flexDirection:"column", gap:14}}>
            {/* E-mail */}
            <div style={{display:"flex", flexDirection:"column", gap:5}}>
              <label style={{fontSize:10, fontWeight:600, color:"#475569", textTransform:"uppercase", letterSpacing:"1.2px"}}>
                E-mail
              </label>
              <input
                className="inp-login"
                type="email"
                value={email}
                onChange={e=>{ setEmail(e.target.value); setErro(""); }}
                placeholder="seu@email.com"
                autoComplete="email"
                autoFocus
              />
            </div>

            {/* Senha */}
            <div style={{display:"flex", flexDirection:"column", gap:5}}>
              <label style={{fontSize:10, fontWeight:600, color:"#475569", textTransform:"uppercase", letterSpacing:"1.2px"}}>
                Senha
              </label>
              <div style={{position:"relative"}}>
                <input
                  className="inp-login"
                  type={mostrarS ? "text" : "password"}
                  value={senha}
                  onChange={e=>{ setSenha(e.target.value); setErro(""); }}
                  placeholder="••••••••"
                  autoComplete="current-password"
                  style={{paddingRight:44}}
                />
                <button
                  type="button"
                  onClick={()=>setMostrarS(v=>!v)}
                  style={{
                    position:"absolute", right:12, top:"50%", transform:"translateY(-50%)",
                    background:"none", border:"none", cursor:"pointer", fontSize:16, lineHeight:1,
                    color:"#334155", padding:2
                  }}
                  title={mostrarS ? "Ocultar senha" : "Mostrar senha"}
                >
                  {mostrarS ? "🙈" : "👁️"}
                </button>
              </div>
            </div>

            {/* Erro */}
            {erro && (
              <div style={{
                background:"#2d1111", border:"1px solid #ef4444",
                borderRadius:8, padding:"9px 13px",
                color:"#fca5a5", fontSize:12, fontWeight:600,
                display:"flex", alignItems:"center", gap:7
              }}>
                ⚠️ {erro}
              </div>
            )}

            {/* Botão */}
            <button className="btn-login" type="submit" disabled={loading} style={{marginTop:4}}>
              {loading
                ? <><span className="spin" style={{marginRight:8}}>⟳</span>Entrando...</>
                : "→ Entrar"
              }
            </button>
          </form>
        </div>

        <div style={{textAlign:"center", marginTop:18, fontSize:11, color:"#1e3a5f"}}>
          Sistema restrito — Granja Cavazzini © {new Date().getFullYear()}
        </div>
      </div>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════
// APP ROOT
// ════════════════════════════════════════════════════════════════
export default function App() {
  const [usuario,  setUsuario]  = useState(null);
  const [authOk,   setAuthOk]   = useState(false); // evita flash de login antes de checar sessão

  const [clientes, setClientes] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [pedidos,  setPedidos]  = useState([]);
  const [tela,  setTela]  = useState("lista");
  const [form,  setForm]  = useState(null);
  const [toast, setToast] = useState(null);
  const [del,   setDel]   = useState(null);
  const [loading, setLoading] = useState(true);
  const [pedidoImpressao, setPedidoImpressao] = useState(null);

  // ── Verifica sessão ao iniciar ────────────────────────────────
  useEffect(() => {
    sb.auth.getSession().then(({ data }) => {
      if (data?.session?.user) setUsuario(data.session.user);
      setAuthOk(true);
    });
    const { data: listener } = sb.auth.onAuthStateChange((_event, session) => {
      setUsuario(session?.user ?? null);
    });
    return () => listener.subscription.unsubscribe();
  }, []);

  const handleLogout = async () => {
    await sb.auth.signOut();
    setUsuario(null);
    setTela("lista");
    setPedidos([]); setClientes([]); setProdutos([]);
  };

  const showToast = (msg, ok=true) => { setToast({msg,ok}); setTimeout(()=>setToast(null),3000); };

  const carregarDados = useCallback(async () => {
    setLoading(true);
    try {
      const [rc, rp, rped] = await Promise.all([
        sb.from("clientes").select("*").order("nome"),
        sb.from("produtos").select("*").order("nome"),
        sb.from("pedidos").select("*").order("created_at", { ascending: false }),
      ]);
      if (rc.data)   setClientes(rc.data);
      if (rp.data)   setProdutos(rp.data);
      if (rped.data) setPedidos(rped.data);
    } catch(e) { showToast("Erro ao carregar dados", false); }
    setLoading(false);
  }, []);

  useEffect(() => { if (usuario) carregarDados(); }, [usuario, carregarDados]);

  // ── Aguarda verificar auth antes de renderizar ────────────────
  if (!authOk) {
    return (
      <div style={{minHeight:"100vh",background:"#080f1c",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'DM Sans',sans-serif"}}>
        <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;700&display=swap');@keyframes spin{to{transform:rotate(360deg)}}.spin{animation:spin 1s linear infinite;display:inline-block;}`}</style>
        <div style={{textAlign:"center"}}>
          <div className="spin" style={{fontSize:40}}>🌿</div>
          <div style={{color:"#1e3a5f",fontSize:13,marginTop:12}}>Carregando...</div>
        </div>
      </div>
    );
  }

  // ── Não logado → tela de login ────────────────────────────────
  if (!usuario) {
    return <TelaLogin onLogin={setUsuario} />;
  }

  const abrirNovo   = () => { setForm(formVazio()); setTela("form"); };
  const abrirEditar = p  => {
    const linhas = [...(p.linhas||[])];
    while(linhas.length<5) linhas.push(linhaVazia());
    setForm({...p, _localId:p.id, linhas, boletos:p.boletos||[{dias:""},{dias:""},{dias:""}]});
    setTela("form");
  };

  const salvar = async (f) => {
    if (!f.pedido.trim()) { showToast("Informe o nº do pedido",false); return; }
    if (!f.nf.trim())     { showToast("Informe a NF",false); return; }
    if (!f.cliente.trim()){ showToast("Informe o cliente",false); return; }
    const totalGeral = f.linhas.reduce((a,l)=>a+(l.total||0),0);
    const taxa       = TAXAS[f.classe]||0;
    const desconto   = f.emiteNfe ? totalGeral*taxa : 0;
    const totalFinal = totalGeral - desconto;
    const payload = {
      pedido:f.pedido, nf:f.nf, data:f.data, mes:f.mes, hora:f.hora,
      cliente:f.cliente, endereco:f.endereco, cidade:f.cidade, uf:f.uf,
      fone:f.fone, cnpj:f.cnpj, ie:f.ie, classe:f.classe,
      linhas:f.linhas, emite_nfe:f.emiteNfe,
      taxa_funrural:taxa, desconto, total_final:totalFinal, total:totalGeral,
      tipo_pgto:f.tipoPgto, qtd_boletos:f.qtdeBol, boletos:f.boletos,
    };
    try {
      if (f.id) { await sb.from("pedidos").update(payload).eq("id", f.id); showToast("Pedido alterado!"); }
      else       { await sb.from("pedidos").insert(payload);                showToast("Pedido salvo!");    }
      await carregarDados();
      setTela("lista");
    } catch(e) { showToast("Erro ao salvar pedido", false); }
  };

  const confirmarDel = async () => {
    if (!del) return;
    try {
      await sb.from(del.tipo).delete().eq("id", del.id);
      showToast("Excluído com sucesso.");
      await carregarDados();
      if (del.tipo==="pedidos" && tela==="form") setTela("lista");
    } catch(e) { showToast("Erro ao excluir", false); }
    setDel(null);
  };

  const salvarCliente = async (item) => {
    if (!item.nome.trim()) return;
    const { id, created_at, ...dados } = item;
    try {
      if (id && typeof id==="number") { await sb.from("clientes").update(dados).eq("id",id); }
      else { await sb.from("clientes").insert(dados); }
      await carregarDados(); showToast("Cliente salvo!");
    } catch(e) { showToast("Erro ao salvar cliente",false); }
  };

  const salvarProduto = async (item) => {
    if (!item.nome.trim()) return;
    const { id, created_at, ...dados } = item;
    try {
      if (id && typeof id==="number") { await sb.from("produtos").update(dados).eq("id",id); }
      else { await sb.from("produtos").insert(dados); }
      await carregarDados(); showToast("Produto salvo!");
    } catch(e) { showToast("Erro ao salvar produto",false); }
  };

  if (pedidoImpressao) {
    return <FolhaPedido pedido={pedidoImpressao} onVoltar={()=>setPedidoImpressao(null)}/>;
  }

  // Nome amigável do usuário
  const nomeUsuario = usuario.user_metadata?.nome || usuario.email?.split("@")[0] || "Usuário";

  return (
    <div style={{minHeight:"100vh",background:"#080f1c",fontFamily:"'DM Sans',system-ui,sans-serif",color:"#e2e8f0"}}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&family=DM+Mono:wght@400;500&display=swap');
        *{box-sizing:border-box;margin:0;padding:0;}
        ::-webkit-scrollbar{width:5px;height:5px;}
        ::-webkit-scrollbar-track{background:#0d1526;}
        ::-webkit-scrollbar-thumb{background:#1e3a5f;border-radius:4px;}
        input,select,button{font-family:inherit;}
        .hover-row:hover{background:rgba(16,185,129,.07)!important;cursor:pointer;}
        @keyframes fadeUp{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}
        .fade{animation:fadeUp .2s ease;}
        @keyframes toastIn{from{opacity:0;transform:translateX(30px)}to{opacity:1;transform:none}}
        .toast-in{animation:toastIn .3s cubic-bezier(.34,1.56,.64,1);}
        .nav-btn{padding:7px 15px;border-radius:8px;border:none;background:transparent;color:#64748b;font-weight:600;font-size:13px;cursor:pointer;transition:color .15s;}
        .nav-btn:hover,.nav-btn.ativo{color:#34d399;}
        .nav-btn.ativo{background:rgba(52,211,153,.1);}
        .ibtn{padding:5px 9px;border-radius:7px;border:1px solid transparent;background:transparent;cursor:pointer;font-size:13px;transition:opacity .15s;}
        .ibtn:hover{opacity:.7;}
        @keyframes spin{to{transform:rotate(360deg)}}
        .spin{animation:spin 1s linear infinite;display:inline-block;}
        .btn-logout{padding:6px 13px;border-radius:8px;border:1px solid rgba(239,68,68,.25);background:rgba(239,68,68,.07);color:#f87171;font-weight:600;font-size:12px;cursor:pointer;transition:all .15s;white-space:nowrap;}
        .btn-logout:hover{background:rgba(239,68,68,.15);border-color:rgba(239,68,68,.45);}
      `}</style>

      {/* HEADER */}
      <header style={{background:"#0d1526",borderBottom:"1px solid rgba(52,211,153,.12)",padding:"0 20px",position:"sticky",top:0,zIndex:500}}>
        <div style={{maxWidth:1280,margin:"0 auto",display:"flex",alignItems:"center",justifyContent:"space-between",height:56}}>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <div style={{width:34,height:34,borderRadius:9,background:"linear-gradient(135deg,#059669,#34d399)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:16}}>🌿</div>
            <div>
              <div style={{fontWeight:800,fontSize:15,letterSpacing:"-.3px",color:"#f1f5f9"}}>AUTOPED</div>
              <div style={{fontSize:9,color:"#334155",letterSpacing:"2px",textTransform:"uppercase"}}>Granja Cavazzini</div>
            </div>
          </div>
          <nav style={{display:"flex",gap:2,flexWrap:"nowrap",alignItems:"center"}}>
            {[["dashboard","📊 Dashboard"],["lista","📋 Pedidos"],["novo","➕ Novo"],["pesquisa","🔍 Pesquisa"],["romaneio","🚛 Romaneio"],["clientes","👤 Clientes"],["produtos","🌾 Produtos"]].map(([id,label])=>(
              <button key={id} className={`nav-btn${(tela===id||(id==="novo"&&tela==="form"))?" ativo":""}`}
                onClick={()=>id==="novo"?abrirNovo():setTela(id)}>{label}</button>
            ))}
          </nav>
          {/* Usuário + Logout */}
          <div style={{display:"flex",alignItems:"center",gap:10,flexShrink:0}}>
            <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:1}}>
              <div style={{fontSize:11,color:"#64748b",fontWeight:600}}>{nomeUsuario}</div>
              {loading && <span className="spin" style={{fontSize:11,color:"#1e3a5f"}}>⟳</span>}
              {!loading && <div style={{fontSize:9,color:"#1e3a5f",fontFamily:"'DM Mono',monospace"}}>{hoje()}</div>}
            </div>
            <button className="btn-logout" onClick={handleLogout} title="Sair do sistema">
              ↩ Sair
            </button>
          </div>
        </div>
      </header>

      {/* TOAST */}
      {toast && (
        <div className="toast-in" style={{position:"fixed",top:68,right:18,zIndex:9999,padding:"10px 16px",borderRadius:10,
          background:toast.ok?"#0a2318":"#2d1111",border:`1px solid ${toast.ok?"#10b981":"#ef4444"}`,
          color:"#f1f5f9",fontSize:13,fontWeight:600,boxShadow:"0 6px 24px rgba(0,0,0,.5)",display:"flex",gap:8,alignItems:"center"}}>
          {toast.ok?"✅":"⚠️"} {toast.msg}
        </div>
      )}

      {/* MODAL DELETE */}
      {del && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.78)",zIndex:8000,display:"flex",alignItems:"center",justifyContent:"center"}}>
          <div className="fade" style={{background:"#0f1a2e",border:"1px solid #1e3a5f",borderRadius:14,padding:28,maxWidth:320,width:"90%",textAlign:"center"}}>
            <div style={{fontSize:34,marginBottom:10}}>🗑️</div>
            <div style={{fontWeight:700,fontSize:15,color:"#f1f5f9",marginBottom:6}}>Confirmar exclusão?</div>
            <div style={{fontSize:13,color:"#475569",marginBottom:22}}>Esta ação não pode ser desfeita.</div>
            <div style={{display:"flex",gap:10,justifyContent:"center"}}>
              <button onClick={()=>setDel(null)} style={{padding:"8px 20px",borderRadius:8,border:"1px solid #1e3a5f",background:"transparent",color:"#64748b",cursor:"pointer",fontWeight:600}}>Cancelar</button>
              <button onClick={confirmarDel} style={{padding:"8px 20px",borderRadius:8,border:"none",background:"#dc2626",color:"#fff",cursor:"pointer",fontWeight:700}}>Excluir</button>
            </div>
          </div>
        </div>
      )}

      {loading && pedidos.length===0 ? (
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",height:"60vh",flexDirection:"column",gap:16}}>
          <div className="spin" style={{fontSize:40}}>🌿</div>
          <div style={{color:"#334155",fontSize:14}}>Carregando dados...</div>
        </div>
      ) : (
        <main style={{maxWidth:1280,margin:"0 auto",padding:"20px 20px 48px"}}>
          {tela==="dashboard" && <TelaDashboard pedidos={pedidos} clientes={clientes}/>}
          {tela==="lista"    && <TelaPedidos pedidos={pedidos} onNovo={abrirNovo} onEditar={abrirEditar} onDel={id=>setDel({tipo:"pedidos",id})} onImprimir={p=>setPedidoImpressao(p)}/>}
          {tela==="form"     && <TelaForm form={form} setForm={setForm} clientes={clientes} produtos={produtos} onSalvar={salvar} onVoltar={()=>setTela("lista")} onDel={id=>setDel({tipo:"pedidos",id})} onImprimir={p=>setPedidoImpressao(p)}/>}
          {tela==="pesquisa" && <TelaPesquisa pedidos={pedidos} onImprimir={p=>setPedidoImpressao(p)} onEditar={abrirEditar}/>}
          {tela==="romaneio" && <TelaRomaneio pedidos={pedidos}/>}
          {tela==="clientes" && <TelaCadastro tipo="clientes" itens={clientes} onSalvar={salvarCliente} onDel={id=>setDel({tipo:"clientes",id})}/>}
          {tela==="produtos" && <TelaCadastro tipo="produtos"  itens={produtos} onSalvar={salvarProduto} onDel={id=>setDel({tipo:"produtos",id})}/>}
        </main>
      )}
    </div>
  );
}

// ════════════════════════════════════════════════════════════════
// TELA DASHBOARD
// ════════════════════════════════════════════════════════════════
function TelaDashboard({ pedidos, clientes }) {
  const meses   = [...new Set(pedidos.map(p=>p.mes).filter(Boolean))].sort();
  const mesAtual = mesHoje();
  const [mesSel,  setMesSel]  = useState(meses.includes(mesAtual) ? mesAtual : (meses[meses.length-1]||""));
  const [mesAte,  setMesAte]  = useState(meses.includes(mesAtual) ? mesAtual : (meses[meses.length-1]||""));
  const [mesDe,   setMesDe]   = useState(meses.includes(mesAtual) ? mesAtual : (meses[0]||""));

  const pedidosMes = pedidos.filter(p => p.mes?.toUpperCase() === mesSel.toUpperCase());
  const totalMes   = pedidosMes.reduce((a,p)=>a+(p.total||0),0);

  const idxDe  = meses.indexOf(mesDe);
  const idxAte = meses.indexOf(mesAte);
  const mesesPeriodo = idxDe<=idxAte ? meses.slice(idxDe, idxAte+1) : [];
  const pedidosPeriodo = pedidos.filter(p => mesesPeriodo.includes(p.mes?.toUpperCase()||p.mes));
  const totalPeriodo   = pedidosPeriodo.reduce((a,p)=>a+(p.total||0),0);

  const produtosMes = {};
  pedidosMes.forEach(p=>{
    (p.linhas||[]).forEach(l=>{
      if (!l.nome||l.nome==="0") return;
      if (!produtosMes[l.nome]) produtosMes[l.nome]={unid:0,cx:0,total:0};
      produtosMes[l.nome].unid  += parseFloat(l.qtde)||0;
      produtosMes[l.nome].cx    += parseFloat(l.cx)||0;
      produtosMes[l.nome].total += parseFloat(l.total)||0;
    });
  });

  const produtosAcum = {};
  pedidosPeriodo.forEach(p=>{
    (p.linhas||[]).forEach(l=>{
      if (!l.nome||l.nome==="0") return;
      if (!produtosAcum[l.nome]) produtosAcum[l.nome]={unid:0,cx:0,total:0};
      produtosAcum[l.nome].unid  += parseFloat(l.qtde)||0;
      produtosAcum[l.nome].cx    += parseFloat(l.cx)||0;
      produtosAcum[l.nome].total += parseFloat(l.total)||0;
    });
  });

  const contagemClientes = {};
  pedidos.forEach(p=>{ if(p.cliente) contagemClientes[p.cliente]=(contagemClientes[p.cliente]||{count:0,cidade:p.cidade,total:0}), contagemClientes[p.cliente].count++, contagemClientes[p.cliente].total+=(p.total||0), contagemClientes[p.cliente].cidade=p.cidade; });
  const top5Clientes = Object.entries(contagemClientes).sort((a,b)=>b[1].count-a[1].count).slice(0,5);

  const contagemCidades = {};
  pedidos.forEach(p=>{ if(p.cidade) contagemCidades[p.cidade]=(contagemCidades[p.cidade]||0)+1; });
  const top5Cidades = Object.entries(contagemCidades).sort((a,b)=>b[1]-a[1]).slice(0,5);
  const maxCidade = top5Cidades[0]?.[1]||1;
  const maxCliente = top5Clientes[0]?.[1]?.count||1;

  const totalProdMes  = Object.values(produtosMes).reduce((a,v)=>a+v.total,0);
  const totalProdAcum = Object.values(produtosAcum).reduce((a,v)=>a+v.total,0);

  const selS = {background:"#1a2840",border:"1px solid #1e3a5f",borderRadius:7,padding:"6px 10px",color:"#e2e8f0",fontSize:12,outline:"none",cursor:"pointer"};

  return (
    <div className="fade">
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:20,flexWrap:"wrap",gap:10}}>
        <div style={{fontSize:17,fontWeight:800,color:"#f1f5f9"}}>📊 Dashboard — Granja Cavazzini</div>
        <div style={{fontSize:11,color:"#334155",fontFamily:"'DM Mono',monospace"}}>{pedidos.length} pedidos no total</div>
      </div>

      <div style={{background:"#0d1526",border:"1px solid rgba(52,211,153,.09)",borderRadius:11,padding:16,marginBottom:16}}>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16,flexWrap:"wrap"}}>
          <div style={{fontSize:11,fontWeight:700,color:"#64748b",textTransform:"uppercase",letterSpacing:"1.2px"}}>Selecione o Mês:</div>
          <select value={mesSel} onChange={e=>setMesSel(e.target.value)} style={selS}>
            {meses.map(m=><option key={m} value={m}>{m}</option>)}
          </select>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:12,marginBottom:16}}>
          {[
            {l:"Total Pedidos",    v:pedidosMes.length,           i:"📦", c:"#10b981"},
            {l:"Total Vendas",     v:fmtMoeda(totalMes),          i:"💰", c:"#f59e0b"},
            {l:"Clientes Ativos",  v:clientes.length,             i:"👥", c:"#818cf8"},
            {l:"Ticket Médio",     v:fmtMoeda(pedidosMes.length>0?totalMes/pedidosMes.length:0), i:"📈", c:"#f472b6"},
          ].map(s=>(
            <div key={s.l} style={{background:"rgba(52,211,153,.04)",border:"1px solid rgba(52,211,153,.1)",borderRadius:10,padding:"14px 16px"}}>
              <div style={{fontSize:20,marginBottom:4}}>{s.i}</div>
              <div style={{fontSize:18,fontWeight:800,color:s.c,fontFamily:"'DM Mono',monospace"}}>{s.v}</div>
              <div style={{fontSize:9,color:"#334155",textTransform:"uppercase",letterSpacing:"1.5px",marginTop:2}}>{s.l}</div>
            </div>
          ))}
        </div>
        <div style={{fontSize:11,fontWeight:700,color:"#64748b",textTransform:"uppercase",letterSpacing:"1.2px",marginBottom:10}}>
          Vendas por Produto — {mesSel}
        </div>
        <div style={{overflowX:"auto"}}>
          <table style={{width:"100%",borderCollapse:"collapse",border:"1px solid rgba(52,211,153,.1)"}}>
            <thead>
              <tr style={{background:"rgba(52,211,153,.06)",borderBottom:"2px solid rgba(52,211,153,.15)"}}>
                {["Produto","Unidades","Total CX","Total R$","% do Mês"].map(h=>(
                  <th key={h} style={{padding:"8px 12px",textAlign:"left",fontSize:9,color:"#64748b",textTransform:"uppercase",letterSpacing:"1.2px",borderRight:"1px solid rgba(52,211,153,.08)"}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Object.keys(produtosMes).length===0
                ? <tr><td colSpan={5} style={{padding:24,textAlign:"center",color:"#334155",fontSize:13}}>Nenhum produto no mês selecionado.</td></tr>
                : Object.entries(produtosMes).sort((a,b)=>b[1].total-a[1].total).map(([nome,v],i)=>(
                  <tr key={nome} style={{borderBottom:"1px solid rgba(52,211,153,.06)",background:i%2?"rgba(255,255,255,.01)":"transparent"}}>
                    <td style={{padding:"8px 12px",fontSize:13,fontWeight:700,color:"#e2e8f0",borderRight:"1px solid rgba(52,211,153,.06)"}}>{nome}</td>
                    <td style={{padding:"8px 12px",fontSize:12,color:"#94a3b8",fontFamily:"'DM Mono',monospace",borderRight:"1px solid rgba(52,211,153,.06)"}}>{v.unid}</td>
                    <td style={{padding:"8px 12px",fontSize:13,fontWeight:700,color:"#34d399",fontFamily:"'DM Mono',monospace",borderRight:"1px solid rgba(52,211,153,.06)"}}>{v.cx} cx</td>
                    <td style={{padding:"8px 12px",fontSize:13,fontWeight:700,color:"#f59e0b",fontFamily:"'DM Mono',monospace",borderRight:"1px solid rgba(52,211,153,.06)"}}>{fmtMoeda(v.total)}</td>
                    <td style={{padding:"8px 12px",fontSize:12,color:"#64748b"}}>
                      <div style={{display:"flex",alignItems:"center",gap:8}}>
                        <div style={{flex:1,height:6,background:"rgba(255,255,255,.06)",borderRadius:3,overflow:"hidden"}}>
                          <div style={{width:`${totalProdMes>0?(v.total/totalProdMes*100):0}%`,height:"100%",background:"linear-gradient(90deg,#059669,#34d399)",borderRadius:3}}/>
                        </div>
                        <span style={{fontSize:11,minWidth:36,textAlign:"right"}}>{totalProdMes>0?(v.total/totalProdMes*100).toFixed(1):0}%</span>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
            <tfoot>
              <tr style={{borderTop:"2px solid rgba(52,211,153,.15)",background:"rgba(52,211,153,.04)"}}>
                <td style={{padding:"8px 12px",fontWeight:800,color:"#f1f5f9",fontSize:13}}>TOTAL GERAL</td>
                <td style={{padding:"8px 12px",fontFamily:"'DM Mono',monospace",fontSize:12,color:"#94a3b8"}}>{Object.values(produtosMes).reduce((a,v)=>a+v.unid,0)}</td>
                <td style={{padding:"8px 12px",fontFamily:"'DM Mono',monospace",fontSize:13,fontWeight:800,color:"#34d399"}}>{Object.values(produtosMes).reduce((a,v)=>a+v.cx,0)} cx</td>
                <td colSpan={2} style={{padding:"8px 12px",fontFamily:"'DM Mono',monospace",fontSize:14,fontWeight:800,color:"#f59e0b"}}>{fmtMoeda(totalProdMes)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <div style={{background:"#0d1526",border:"1px solid rgba(99,102,241,.15)",borderRadius:11,padding:16,marginBottom:16}}>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16,flexWrap:"wrap"}}>
          <div style={{fontSize:11,fontWeight:700,color:"#64748b",textTransform:"uppercase",letterSpacing:"1.2px"}}>Resumo Acumulado —</div>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <span style={{fontSize:11,color:"#64748b"}}>De:</span>
            <select value={mesDe} onChange={e=>setMesDe(e.target.value)} style={selS}>
              {meses.map(m=><option key={m} value={m}>{m}</option>)}
            </select>
            <span style={{fontSize:11,color:"#64748b"}}>Até:</span>
            <select value={mesAte} onChange={e=>setMesAte(e.target.value)} style={selS}>
              {meses.map(m=><option key={m} value={m}>{m}</option>)}
            </select>
          </div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:12,marginBottom:16}}>
          {[
            {l:"Pedidos no Período",  v:pedidosPeriodo.length,  i:"📦", c:"#10b981"},
            {l:"Total Vendas",        v:fmtMoeda(totalPeriodo), i:"💰", c:"#f59e0b"},
          ].map(s=>(
            <div key={s.l} style={{background:"rgba(99,102,241,.06)",border:"1px solid rgba(99,102,241,.15)",borderRadius:10,padding:"14px 16px"}}>
              <div style={{fontSize:20,marginBottom:4}}>{s.i}</div>
              <div style={{fontSize:18,fontWeight:800,color:s.c,fontFamily:"'DM Mono',monospace"}}>{s.v}</div>
              <div style={{fontSize:9,color:"#334155",textTransform:"uppercase",letterSpacing:"1.5px",marginTop:2}}>{s.l}</div>
            </div>
          ))}
        </div>
        <div style={{fontSize:11,fontWeight:700,color:"#64748b",textTransform:"uppercase",letterSpacing:"1.2px",marginBottom:10}}>
          Vendas por Produto — Acumulado
        </div>
        <div style={{overflowX:"auto"}}>
          <table style={{width:"100%",borderCollapse:"collapse",border:"1px solid rgba(99,102,241,.12)"}}>
            <thead>
              <tr style={{background:"rgba(99,102,241,.06)",borderBottom:"2px solid rgba(99,102,241,.15)"}}>
                {["Produto","Qtde Unid","Total CX","Total R$","% do Período"].map(h=>(
                  <th key={h} style={{padding:"8px 12px",textAlign:"left",fontSize:9,color:"#64748b",textTransform:"uppercase",letterSpacing:"1.2px",borderRight:"1px solid rgba(99,102,241,.08)"}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Object.keys(produtosAcum).length===0
                ? <tr><td colSpan={5} style={{padding:24,textAlign:"center",color:"#334155",fontSize:13}}>Nenhum dado no período.</td></tr>
                : Object.entries(produtosAcum).sort((a,b)=>b[1].total-a[1].total).map(([nome,v],i)=>(
                  <tr key={nome} style={{borderBottom:"1px solid rgba(99,102,241,.06)",background:i%2?"rgba(255,255,255,.01)":"transparent"}}>
                    <td style={{padding:"8px 12px",fontSize:13,fontWeight:700,color:"#e2e8f0",borderRight:"1px solid rgba(99,102,241,.06)"}}>{nome}</td>
                    <td style={{padding:"8px 12px",fontSize:12,color:"#94a3b8",fontFamily:"'DM Mono',monospace",borderRight:"1px solid rgba(99,102,241,.06)"}}>{v.unid}</td>
                    <td style={{padding:"8px 12px",fontSize:13,fontWeight:700,color:"#34d399",fontFamily:"'DM Mono',monospace",borderRight:"1px solid rgba(99,102,241,.06)"}}>{v.cx} cx</td>
                    <td style={{padding:"8px 12px",fontSize:13,fontWeight:700,color:"#f59e0b",fontFamily:"'DM Mono',monospace",borderRight:"1px solid rgba(99,102,241,.06)"}}>{fmtMoeda(v.total)}</td>
                    <td style={{padding:"8px 12px",fontSize:12,color:"#64748b"}}>
                      <div style={{display:"flex",alignItems:"center",gap:8}}>
                        <div style={{flex:1,height:6,background:"rgba(255,255,255,.06)",borderRadius:3,overflow:"hidden"}}>
                          <div style={{width:`${totalProdAcum>0?(v.total/totalProdAcum*100):0}%`,height:"100%",background:"linear-gradient(90deg,#4f46e5,#818cf8)",borderRadius:3}}/>
                        </div>
                        <span style={{fontSize:11,minWidth:36,textAlign:"right"}}>{totalProdAcum>0?(v.total/totalProdAcum*100).toFixed(1):0}%</span>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
            <tfoot>
              <tr style={{borderTop:"2px solid rgba(99,102,241,.15)",background:"rgba(99,102,241,.04)"}}>
                <td style={{padding:"8px 12px",fontWeight:800,color:"#f1f5f9",fontSize:13}}>TOTAL GERAL</td>
                <td style={{padding:"8px 12px",fontFamily:"'DM Mono',monospace",fontSize:12,color:"#94a3b8"}}>{Object.values(produtosAcum).reduce((a,v)=>a+v.unid,0)}</td>
                <td style={{padding:"8px 12px",fontFamily:"'DM Mono',monospace",fontSize:13,fontWeight:800,color:"#34d399"}}>{Object.values(produtosAcum).reduce((a,v)=>a+v.cx,0)} cx</td>
                <td colSpan={2} style={{padding:"8px 12px",fontFamily:"'DM Mono',monospace",fontSize:14,fontWeight:800,color:"#f59e0b"}}>{fmtMoeda(totalProdAcum)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(340px,1fr))",gap:16}}>
        <div style={{background:"#0d1526",border:"1px solid rgba(244,114,182,.12)",borderRadius:11,overflow:"hidden"}}>
          <div style={{padding:"12px 16px",borderBottom:"1px solid rgba(244,114,182,.1)",background:"rgba(244,114,182,.04)"}}>
            <span style={{fontSize:12,fontWeight:700,color:"#475569"}}>🏆 Top 5 Clientes — Maior Volume de Pedidos</span>
          </div>
          <div style={{padding:16}}>
            {top5Clientes.map(([nome,v],i)=>(
              <div key={nome} style={{display:"flex",alignItems:"center",gap:12,marginBottom:i<4?14:0}}>
                <div style={{width:24,height:24,borderRadius:"50%",background:i===0?"linear-gradient(135deg,#f59e0b,#fbbf24)":i===1?"linear-gradient(135deg,#94a3b8,#cbd5e1)":i===2?"linear-gradient(135deg,#b45309,#d97706)":"rgba(255,255,255,.06)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:800,color:i<3?"#000":"#64748b",flexShrink:0}}>
                  {i+1}
                </div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:12,fontWeight:600,color:"#e2e8f0",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{nome}</div>
                  <div style={{fontSize:10,color:"#475569",marginTop:1}}>{v.cidade} · {fmtMoeda(v.total)}</div>
                  <div style={{marginTop:4,height:5,background:"rgba(255,255,255,.06)",borderRadius:3,overflow:"hidden"}}>
                    <div style={{width:`${(v.count/maxCliente)*100}%`,height:"100%",background:"linear-gradient(90deg,#db2777,#f472b6)",borderRadius:3}}/>
                  </div>
                </div>
                <div style={{fontSize:16,fontWeight:800,color:"#f472b6",fontFamily:"'DM Mono',monospace",flexShrink:0}}>{v.count}</div>
              </div>
            ))}
          </div>
        </div>
        <div style={{background:"#0d1526",border:"1px solid rgba(251,191,36,.12)",borderRadius:11,overflow:"hidden"}}>
          <div style={{padding:"12px 16px",borderBottom:"1px solid rgba(251,191,36,.1)",background:"rgba(251,191,36,.04)"}}>
            <span style={{fontSize:12,fontWeight:700,color:"#475569"}}>🏙️ Top 5 Cidades — Maior Volume de Pedidos</span>
          </div>
          <div style={{padding:16}}>
            {top5Cidades.map(([cidade,count],i)=>(
              <div key={cidade} style={{display:"flex",alignItems:"center",gap:12,marginBottom:i<4?14:0}}>
                <div style={{width:24,height:24,borderRadius:"50%",background:i===0?"linear-gradient(135deg,#f59e0b,#fbbf24)":i===1?"linear-gradient(135deg,#94a3b8,#cbd5e1)":i===2?"linear-gradient(135deg,#b45309,#d97706)":"rgba(255,255,255,.06)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:800,color:i<3?"#000":"#64748b",flexShrink:0}}>
                  {i+1}
                </div>
                <div style={{flex:1}}>
                  <div style={{fontSize:13,fontWeight:600,color:"#e2e8f0"}}>{cidade}</div>
                  <div style={{marginTop:4,height:5,background:"rgba(255,255,255,.06)",borderRadius:3,overflow:"hidden"}}>
                    <div style={{width:`${(count/maxCidade)*100}%`,height:"100%",background:"linear-gradient(90deg,#d97706,#fbbf24)",borderRadius:3}}/>
                  </div>
                </div>
                <div style={{fontSize:16,fontWeight:800,color:"#fbbf24",fontFamily:"'DM Mono',monospace",flexShrink:0}}>{count}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function TelaPedidos({ pedidos, onNovo, onEditar, onDel, onImprimir }) {
  const [busca, setBusca] = useState("");
  const lista = pedidos.filter(p=>!busca||[p.pedido,p.nf,p.cliente,p.cidade].some(v=>String(v||"").toLowerCase().includes(busca.toLowerCase())));
  const totalVol = pedidos.reduce((a,p)=>a+(p.total||0),0);
  return (
    <div className="fade">
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(155px,1fr))",gap:12,marginBottom:20}}>
        {[{l:"Pedidos",v:pedidos.length,i:"📦",c:"#10b981"},{l:"Volume Total",v:fmtMoeda(totalVol),i:"💰",c:"#f59e0b"},
          {l:"Com NF-e",v:pedidos.filter(p=>p.emite_nfe).length,i:"🧾",c:"#818cf8"},{l:"Boletos",v:pedidos.filter(p=>p.tipo_pgto==="BOLETO").length,i:"📄",c:"#f472b6"}
        ].map(s=>(
          <div key={s.l} style={{background:"#0d1526",border:"1px solid rgba(52,211,153,.09)",borderRadius:11,padding:"14px 16px"}}>
            <div style={{fontSize:20,marginBottom:4}}>{s.i}</div>
            <div style={{fontSize:20,fontWeight:800,color:s.c,fontFamily:"'DM Mono',monospace"}}>{s.v}</div>
            <div style={{fontSize:9,color:"#334155",textTransform:"uppercase",letterSpacing:"1.5px",marginTop:2}}>{s.l}</div>
          </div>
        ))}
      </div>
      <div style={{display:"flex",gap:10,marginBottom:12,alignItems:"center"}}>
        <div style={{flex:1,position:"relative"}}>
          <span style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",color:"#334155"}}>🔍</span>
          <input value={busca} onChange={e=>setBusca(e.target.value)} placeholder="Buscar por pedido, cliente, NF..."
            style={{width:"100%",background:"#0d1526",border:"1px solid #1e3a5f",borderRadius:8,padding:"9px 12px 9px 34px",color:"#e2e8f0",fontSize:13,outline:"none"}}/>
        </div>
        <button onClick={onNovo} style={{padding:"9px 18px",borderRadius:8,border:"none",background:"linear-gradient(135deg,#059669,#10b981)",color:"#fff",fontWeight:700,fontSize:13,cursor:"pointer",whiteSpace:"nowrap",boxShadow:"0 3px 12px rgba(16,185,129,.28)"}}>+ Novo Pedido</button>
      </div>
      <div style={{background:"#0d1526",border:"1px solid rgba(52,211,153,.09)",borderRadius:11,overflow:"hidden"}}>
        <div style={{overflowX:"auto"}}>
          <table style={{width:"100%",borderCollapse:"collapse",minWidth:720}}>
            <thead>
              <tr style={{borderBottom:"1px solid rgba(52,211,153,.09)",background:"rgba(52,211,153,.025)"}}>
                {["Pedido","NF","Data","Mês","Cliente","Cidade/UF","Total","Pgto","NF-e",""].map(h=>(
                  <th key={h} style={{padding:"10px 13px",textAlign:"left",fontSize:9,color:"#334155",textTransform:"uppercase",letterSpacing:"1.2px",whiteSpace:"nowrap"}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {lista.length===0
                ? <tr><td colSpan={10} style={{padding:48,textAlign:"center",color:"#1e3a5f",fontSize:13}}>Nenhum pedido encontrado.<br/><span style={{fontSize:11}}>Clique em "+ Novo Pedido" para começar.</span></td></tr>
                : lista.map((p,i)=>(
                  <tr key={p.id} className="hover-row" onClick={()=>onEditar(p)} style={{borderBottom:"1px solid rgba(255,255,255,.04)",background:i%2?"rgba(255,255,255,.01)":"transparent"}}>
                    <td style={{padding:"10px 13px",fontFamily:"'DM Mono',monospace",fontSize:13,color:"#34d399",fontWeight:700}}>#{p.pedido}</td>
                    <td style={{padding:"10px 13px",fontSize:12,color:"#64748b"}}>{p.nf}</td>
                    <td style={{padding:"10px 13px",fontSize:11,color:"#334155",fontFamily:"'DM Mono',monospace"}}>{p.data}</td>
                    <td style={{padding:"10px 13px"}}><Chip c="blue">{(p.mes||"").slice(0,3)}</Chip></td>
                    <td style={{padding:"10px 13px",fontSize:13,color:"#e2e8f0",fontWeight:500,maxWidth:190,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.cliente}</td>
                    <td style={{padding:"10px 13px",fontSize:11,color:"#475569"}}>{p.cidade}/{p.uf}</td>
                    <td style={{padding:"10px 13px",fontFamily:"'DM Mono',monospace",fontSize:13,color:"#f59e0b",fontWeight:700}}>{fmtMoeda(p.total)}</td>
                    <td style={{padding:"10px 13px"}}><Chip c={p.tipo_pgto==="BOLETO"?"amber":p.tipo_pgto==="PIX"?"green":"blue"}>{p.tipo_pgto||"—"}</Chip></td>
                    <td style={{padding:"10px 13px"}}>{p.emite_nfe?<Chip c="green">SIM</Chip>:<span style={{color:"#1e3a5f"}}>—</span>}</td>
                    <td style={{padding:"10px 13px"}} onClick={e=>e.stopPropagation()}>
                      <div style={{display:"flex",gap:4}}>
                        <button className="ibtn" style={{borderColor:"#60a5fa22",color:"#60a5fa"}} onClick={()=>onEditar(p)}>✏️</button>
                        <button className="ibtn" style={{borderColor:"#a78bfa22",color:"#a78bfa"}} onClick={()=>onImprimir(p)}>🖨️</button>
                        <button className="ibtn" style={{borderColor:"#f8717122",color:"#f87171"}} onClick={()=>onDel(p.id)}>🗑️</button>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

function TelaPesquisa({ pedidos, onImprimir, onEditar }) {
  const [mesFiltro,    setMesFiltro]    = useState("");
  const [cidadeFiltro, setCidadeFiltro] = useState("");
  const [pedidoFiltro, setPedidoFiltro] = useState("");
  const [dataIni,      setDataIni]      = useState("");
  const [dataFim,      setDataFim]      = useState("");
  const [selecionados, setSelecionados] = useState({});

  const cidades = [...new Set(pedidos.map(p=>p.cidade).filter(Boolean))].sort();
  const meses   = [...new Set(pedidos.map(p=>p.mes).filter(Boolean))].sort();

  const parseData = s => {
    if (!s) return null;
    const [d,m,a] = s.split("/");
    return new Date(`${a}-${m}-${d}`);
  };

  const filtrados = pedidos.filter(p => {
    if (mesFiltro    && p.mes?.toUpperCase() !== mesFiltro.toUpperCase()) return false;
    if (cidadeFiltro && p.cidade?.toLowerCase() !== cidadeFiltro.toLowerCase()) return false;
    if (pedidoFiltro && !String(p.pedido||"").includes(pedidoFiltro)) return false;
    if (dataIni) { const d=parseData(dataIni), pd=parseData(p.data); if(pd&&d&&pd<d) return false; }
    if (dataFim) { const d=parseData(dataFim), pd=parseData(p.data); if(pd&&d&&pd>d) return false; }
    return true;
  });

  const toggleSel = id => setSelecionados(s=>({...s,[id]:!s[id]}));
  const toggleTodos = () => {
    const todos = filtrados.every(p=>selecionados[p.id]);
    const novo = {};
    filtrados.forEach(p=>{ novo[p.id]=!todos; });
    setSelecionados(s=>({...s,...novo}));
  };
  const selecionadosList = filtrados.filter(p=>selecionados[p.id]);
  const totalSel = selecionadosList.reduce((a,p)=>a+(p.total||0),0);

  return (
    <div className="fade">
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16,flexWrap:"wrap",gap:10}}>
        <div style={{fontSize:17,fontWeight:800,color:"#f1f5f9"}}>🔍 Pesquisa de Pedidos</div>
        {selecionadosList.length>0 && (
          <div style={{display:"flex",gap:8,alignItems:"center"}}>
            <span style={{fontSize:13,color:"#64748b"}}>{selecionadosList.length} selecionado(s) · {fmtMoeda(totalSel)}</span>
          </div>
        )}
      </div>
      <div style={{background:"#0d1526",border:"1px solid rgba(52,211,153,.09)",borderRadius:11,padding:16,marginBottom:16}}>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))",gap:12}}>
          <FI label="Nº Pedido" value={pedidoFiltro} onChange={setPedidoFiltro} placeholder="Ex: 12321"/>
          <div style={{display:"flex",flexDirection:"column",gap:3}}>
            <label style={{fontSize:9,fontWeight:600,color:"#475569",textTransform:"uppercase",letterSpacing:"1.2px"}}>Mês</label>
            <select value={mesFiltro} onChange={e=>setMesFiltro(e.target.value)} style={{background:"#1a2840",border:"1px solid #1e3a5f",borderRadius:7,padding:"8px 10px",color:"#e2e8f0",fontSize:12,outline:"none"}}>
              <option value="">Todos</option>
              {meses.map(m=><option key={m} value={m}>{m}</option>)}
            </select>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:3}}>
            <label style={{fontSize:9,fontWeight:600,color:"#475569",textTransform:"uppercase",letterSpacing:"1.2px"}}>Cidade</label>
            <select value={cidadeFiltro} onChange={e=>setCidadeFiltro(e.target.value)} style={{background:"#1a2840",border:"1px solid #1e3a5f",borderRadius:7,padding:"8px 10px",color:"#e2e8f0",fontSize:12,outline:"none"}}>
              <option value="">Todas</option>
              {cidades.map(c=><option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <FI label="Data Inicial" value={dataIni} onChange={setDataIni} placeholder="dd/mm/aaaa"/>
          <FI label="Data Final"   value={dataFim} onChange={setDataFim} placeholder="dd/mm/aaaa"/>
          <div style={{display:"flex",alignItems:"flex-end"}}>
            <button onClick={()=>{setMesFiltro("");setCidadeFiltro("");setPedidoFiltro("");setDataIni("");setDataFim("");setSelecionados({});}}
              style={{padding:"8px 16px",borderRadius:7,border:"1px solid #1e3a5f",background:"transparent",color:"#64748b",cursor:"pointer",fontSize:12,fontWeight:600,width:"100%"}}>
              🗑️ Limpar
            </button>
          </div>
        </div>
      </div>
      <div style={{background:"#0d1526",border:"1px solid rgba(52,211,153,.09)",borderRadius:11,overflow:"hidden"}}>
        <div style={{padding:"10px 16px",borderBottom:"1px solid rgba(52,211,153,.06)",background:"rgba(52,211,153,.02)",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <span style={{fontSize:12,fontWeight:700,color:"#475569"}}>{filtrados.length} pedido(s) encontrado(s)</span>
          <span style={{fontSize:12,color:"#f59e0b",fontWeight:700}}>{fmtMoeda(filtrados.reduce((a,p)=>a+(p.total||0),0))}</span>
        </div>
        <div style={{overflowX:"auto"}}>
          <table style={{width:"100%",borderCollapse:"collapse",minWidth:680}}>
            <thead>
              <tr style={{borderBottom:"1px solid rgba(52,211,153,.09)",background:"rgba(52,211,153,.025)"}}>
                <th style={{padding:"10px 13px",width:40}}>
                  <input type="checkbox" checked={filtrados.length>0&&filtrados.every(p=>selecionados[p.id])} onChange={toggleTodos} style={{accentColor:"#10b981",cursor:"pointer"}}/>
                </th>
                {["Pedido","NF","Data","Mês","Cliente","Cidade/UF","Total","Pgto",""].map(h=>(
                  <th key={h} style={{padding:"10px 13px",textAlign:"left",fontSize:9,color:"#334155",textTransform:"uppercase",letterSpacing:"1.2px",whiteSpace:"nowrap"}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtrados.length===0
                ? <tr><td colSpan={10} style={{padding:36,textAlign:"center",color:"#1e3a5f",fontSize:13}}>Nenhum pedido com estes filtros.</td></tr>
                : filtrados.map((p,i)=>(
                  <tr key={p.id} style={{borderBottom:"1px solid rgba(255,255,255,.04)",background:selecionados[p.id]?"rgba(52,211,153,.06)":i%2?"rgba(255,255,255,.01)":"transparent"}}>
                    <td style={{padding:"10px 13px"}}>
                      <input type="checkbox" checked={!!selecionados[p.id]} onChange={()=>toggleSel(p.id)} style={{accentColor:"#10b981",cursor:"pointer"}}/>
                    </td>
                    <td style={{padding:"10px 13px",fontFamily:"'DM Mono',monospace",fontSize:13,color:"#34d399",fontWeight:700}}>#{p.pedido}</td>
                    <td style={{padding:"10px 13px",fontSize:12,color:"#64748b"}}>{p.nf||"—"}</td>
                    <td style={{padding:"10px 13px",fontSize:11,color:"#334155",fontFamily:"'DM Mono',monospace"}}>{p.data}</td>
                    <td style={{padding:"10px 13px"}}><Chip c="blue">{(p.mes||"").slice(0,3)}</Chip></td>
                    <td style={{padding:"10px 13px",fontSize:13,color:"#e2e8f0",fontWeight:500,maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.cliente}</td>
                    <td style={{padding:"10px 13px",fontSize:11,color:"#475569"}}>{p.cidade}/{p.uf}</td>
                    <td style={{padding:"10px 13px",fontFamily:"'DM Mono',monospace",fontSize:13,color:"#f59e0b",fontWeight:700}}>{fmtMoeda(p.total)}</td>
                    <td style={{padding:"10px 13px"}}><Chip c={p.tipo_pgto==="BOLETO"?"amber":p.tipo_pgto==="PIX"?"green":"blue"}>{p.tipo_pgto||"—"}</Chip></td>
                    <td style={{padding:"10px 13px"}} onClick={e=>e.stopPropagation()}>
                      <div style={{display:"flex",gap:4}}>
                        <button className="ibtn" style={{borderColor:"#60a5fa22",color:"#60a5fa"}} onClick={()=>onEditar(p)}>✏️</button>
                        <button className="ibtn" style={{borderColor:"#a78bfa22",color:"#a78bfa"}} onClick={()=>onImprimir(p)}>🖨️</button>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

function TelaRomaneio({ pedidos }) {
  const [mesFiltro,    setMesFiltro]    = useState(mesHoje());
  const [cidadeFiltro, setCidadeFiltro] = useState("");
  const [dataIni,      setDataIni]      = useState("");
  const [dataFim,      setDataFim]      = useState("");
  const [selecionados, setSelecionados] = useState({});

  const cidades = [...new Set(pedidos.map(p=>p.cidade).filter(Boolean))].sort();
  const meses   = [...new Set(pedidos.map(p=>p.mes).filter(Boolean))].sort();

  const parseData = s => { if(!s) return null; const [d,m,a]=s.split("/"); return new Date(`${a}-${m}-${d}`); };

  const filtrados = pedidos.filter(p => {
    if (mesFiltro    && p.mes?.toUpperCase()!==mesFiltro.toUpperCase()) return false;
    if (cidadeFiltro && p.cidade?.toLowerCase()!==cidadeFiltro.toLowerCase()) return false;
    if (dataIni) { const d=parseData(dataIni),pd=parseData(p.data); if(pd&&d&&pd<d) return false; }
    if (dataFim) { const d=parseData(dataFim),pd=parseData(p.data); if(pd&&d&&pd>d) return false; }
    return true;
  });

  useEffect(()=>{
    const sel = {};
    filtrados.forEach(p=>{ sel[p.id]=true; });
    setSelecionados(sel);
  },[mesFiltro,cidadeFiltro,dataIni,dataFim]);

  const toggleSel  = id => setSelecionados(s=>({...s,[id]:!s[id]}));
  const toggleTodos = () => {
    const todos = filtrados.every(p=>selecionados[p.id]);
    const novo = {}; filtrados.forEach(p=>{novo[p.id]=!todos;});
    setSelecionados(s=>({...s,...novo}));
  };

  const noRomaneio = filtrados.filter(p=>selecionados[p.id]);
  const totalGeral = noRomaneio.reduce((a,p)=>a+(p.total||0),0);

  const totProdutos = {};
  noRomaneio.forEach(p=>{
    (p.linhas||[]).forEach(l=>{
      if (!l.nome||l.nome==="0") return;
      if (!totProdutos[l.nome]) totProdutos[l.nome]={cx:0,total:0};
      totProdutos[l.nome].cx    += parseFloat(l.cx)||0;
      totProdutos[l.nome].total += parseFloat(l.total)||0;
    });
  });

  return (
    <div className="fade">
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16,flexWrap:"wrap",gap:10}}>
        <div style={{fontSize:17,fontWeight:800,color:"#f1f5f9"}}>🚛 Romaneio de Carregamento</div>
        <button onClick={()=>window.print()} className="no-print" style={{padding:"8px 18px",borderRadius:8,border:"none",background:"linear-gradient(135deg,#7c3aed,#a78bfa)",color:"#fff",fontWeight:700,fontSize:13,cursor:"pointer"}}>
          🖨️ Imprimir Romaneio
        </button>
      </div>
      <div style={{background:"#0d1526",border:"1px solid rgba(52,211,153,.09)",borderRadius:11,padding:16,marginBottom:16}} className="no-print">
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))",gap:12}}>
          <div style={{display:"flex",flexDirection:"column",gap:3}}>
            <label style={{fontSize:9,fontWeight:600,color:"#475569",textTransform:"uppercase",letterSpacing:"1.2px"}}>Mês</label>
            <select value={mesFiltro} onChange={e=>setMesFiltro(e.target.value)} style={{background:"#1a2840",border:"1px solid #1e3a5f",borderRadius:7,padding:"8px 10px",color:"#e2e8f0",fontSize:12,outline:"none"}}>
              <option value="">Todos</option>
              {meses.map(m=><option key={m} value={m}>{m}</option>)}
            </select>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:3}}>
            <label style={{fontSize:9,fontWeight:600,color:"#475569",textTransform:"uppercase",letterSpacing:"1.2px"}}>Cidade</label>
            <select value={cidadeFiltro} onChange={e=>setCidadeFiltro(e.target.value)} style={{background:"#1a2840",border:"1px solid #1e3a5f",borderRadius:7,padding:"8px 10px",color:"#e2e8f0",fontSize:12,outline:"none"}}>
              <option value="">Todas</option>
              {cidades.map(c=><option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <FI label="Data Inicial" value={dataIni} onChange={setDataIni} placeholder="dd/mm/aaaa"/>
          <FI label="Data Final"   value={dataFim} onChange={setDataFim} placeholder="dd/mm/aaaa"/>
        </div>
      </div>
      <div style={{background:"#0d1526",border:"1px solid rgba(52,211,153,.09)",borderRadius:11,overflow:"hidden",marginBottom:16}}>
        <div style={{padding:"10px 16px",borderBottom:"1px solid rgba(52,211,153,.06)",background:"rgba(52,211,153,.02)",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span style={{fontSize:12,fontWeight:700,color:"#475569"}}>GRANJA CAVAZZINI — CONTROLE DE CARREGAMENTO</span>
          <span style={{fontSize:12,color:"#f59e0b",fontWeight:700}}>{noRomaneio.length} pedido(s) · {fmtMoeda(totalGeral)}</span>
        </div>
        <div style={{overflowX:"auto"}}>
          <table style={{width:"100%",borderCollapse:"collapse",minWidth:800,border:"1px solid rgba(52,211,153,.15)"}}>
            <thead>
              <tr style={{borderBottom:"2px solid rgba(52,211,153,.2)",background:"rgba(52,211,153,.025)"}}>
                <th style={{padding:"8px 10px",width:36,borderRight:"1px solid rgba(52,211,153,.1)"}} className="no-print">
                  <input type="checkbox" checked={filtrados.length>0&&filtrados.every(p=>selecionados[p.id])} onChange={toggleTodos} style={{accentColor:"#10b981",cursor:"pointer"}}/>
                </th>
                {["Pedido","NF","Cidade","Cliente","Prod 1","CX","Prod 2","CX","Prod 3","CX","Total","Pgto"].map((h,i)=>(
                  <th key={i} style={{padding:"8px 10px",textAlign:"left",fontSize:9,color:"#334155",textTransform:"uppercase",letterSpacing:"1.2px",whiteSpace:"nowrap"}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {noRomaneio.length===0
                ? <tr><td colSpan={13} style={{padding:36,textAlign:"center",color:"#1e3a5f",fontSize:13}}>Nenhum pedido selecionado.</td></tr>
                : noRomaneio.map((p,i)=>{
                  const ls = (p.linhas||[]).filter(l=>l.nome&&l.nome!=="0");
                  return (
                    <tr key={p.id} style={{borderBottom:"1px solid rgba(255,255,255,.04)",background:i%2?"rgba(255,255,255,.01)":"transparent"}}>
                      <td style={{padding:"8px 10px"}} className="no-print">
                        <input type="checkbox" checked={!!selecionados[p.id]} onChange={()=>toggleSel(p.id)} style={{accentColor:"#10b981",cursor:"pointer"}}/>
                      </td>
                      <td style={{padding:"8px 10px",fontFamily:"'DM Mono',monospace",fontSize:12,color:"#34d399",fontWeight:700,borderRight:"1px solid rgba(52,211,153,.08)"}}>#{p.pedido}</td>
                      <td style={{padding:"8px 10px",fontSize:11,color:"#64748b",borderRight:"1px solid rgba(52,211,153,.08)"}}>{p.nf||"—"}</td>
                      <td style={{padding:"8px 10px",fontSize:11,color:"#94a3b8",whiteSpace:"nowrap",borderRight:"1px solid rgba(52,211,153,.08)"}}>{p.cidade}</td>
                      <td style={{padding:"8px 10px",fontSize:11,color:"#e2e8f0",maxWidth:160,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",borderRight:"1px solid rgba(52,211,153,.08)"}}>{p.cliente}</td>
                      {[0,1,2].map(idx=>(
                        <><td key={`p${idx}`} style={{padding:"8px 10px",fontSize:11,color:"#94a3b8",whiteSpace:"nowrap",borderRight:"1px solid rgba(52,211,153,.08)"}}>{ls[idx]?.nome||"—"}</td>
                        <td key={`cx${idx}`} style={{padding:"8px 10px",fontSize:12,color:"#34d399",fontFamily:"'DM Mono',monospace",fontWeight:700,textAlign:"center",borderRight:"1px solid rgba(52,211,153,.08)"}}>{ls[idx]?.cx||"—"}</td></>
                      ))}
                      <td style={{padding:"8px 10px",fontFamily:"'DM Mono',monospace",fontSize:12,color:"#f59e0b",fontWeight:700}}>{fmtMoeda(p.total)}</td>
                      <td style={{padding:"8px 10px"}}><Chip c={p.tipo_pgto==="BOLETO"?"amber":p.tipo_pgto==="PIX"?"green":"blue"}>{p.tipo_pgto||"—"}</Chip></td>
                    </tr>
                  );
                })}
            </tbody>
            <tfoot>
              <tr style={{borderTop:"2px solid rgba(52,211,153,.2)",background:"rgba(52,211,153,.04)"}}>
                <td colSpan={11} style={{padding:"10px 13px",fontSize:13,fontWeight:800,color:"#f59e0b",textAlign:"right",fontFamily:"'DM Mono',monospace"}}>TOTAL GERAL:</td>
                <td style={{padding:"10px 13px",fontSize:14,fontWeight:800,color:"#f59e0b",fontFamily:"'DM Mono',monospace"}}>{fmtMoeda(totalGeral)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      {Object.keys(totProdutos).length>0 && (
        <div style={{background:"#0d1526",border:"1px solid rgba(52,211,153,.09)",borderRadius:11,overflow:"hidden"}}>
          <div style={{padding:"10px 16px",borderBottom:"1px solid rgba(52,211,153,.06)",background:"rgba(52,211,153,.02)"}}>
            <span style={{fontSize:12,fontWeight:700,color:"#475569"}}>📦 TOTAL DE CAIXAS POR PRODUTO</span>
          </div>
          <div style={{overflowX:"auto"}}>
            <table style={{width:"100%",borderCollapse:"collapse",border:"1px solid rgba(52,211,153,.1)"}}>
              <thead>
                <tr style={{borderBottom:"2px solid rgba(52,211,153,.2)",background:"rgba(52,211,153,.025)"}}>
                  {["Produto","Total CX","Valor Total"].map(h=>(
                    <th key={h} style={{padding:"8px 13px",textAlign:"left",fontSize:9,color:"#334155",textTransform:"uppercase",letterSpacing:"1.2px",borderRight:"1px solid rgba(52,211,153,.1)"}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {Object.entries(totProdutos).map(([nome,v],i)=>(
                  <tr key={nome} style={{borderBottom:"1px solid rgba(52,211,153,.08)",background:i%2?"rgba(255,255,255,.01)":"transparent"}}>
                    <td style={{padding:"8px 13px",fontSize:13,color:"#e2e8f0",fontWeight:600,borderRight:"1px solid rgba(52,211,153,.08)"}}>{nome}</td>
                    <td style={{padding:"8px 13px",fontSize:14,fontWeight:800,color:"#34d399",fontFamily:"'DM Mono',monospace",borderRight:"1px solid rgba(52,211,153,.08)"}}>{v.cx} cx</td>
                    <td style={{padding:"8px 13px",fontSize:13,color:"#f59e0b",fontFamily:"'DM Mono',monospace",fontWeight:700}}>{fmtMoeda(v.total)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      <style>{`
        @media print{
          .no-print{display:none!important;}
          body{background:#fff!important;color:#000!important;}
          table{border:1px solid #cbd5e1!important;border-collapse:collapse!important;}
          th{background:#f1f5f9!important;border:1px solid #cbd5e1!important;padding:6px 10px!important;-webkit-print-color-adjust:exact;print-color-adjust:exact;}
          td{border:1px solid #e2e8f0!important;padding:6px 10px!important;}
          tr{border-bottom:1px solid #e2e8f0!important;}
        }
      `}</style>
    </div>
  );
}

function FolhaPedido({ pedido: p, onVoltar }) {
  useEffect(()=>{ document.title = `Pedido #${p.pedido} - ${p.cliente}`; return ()=>{ document.title="AUTOPED"; }; },[p]);
  const linhas = (p.linhas||[]).filter(l=>l.nome&&l.nome!=="0"&&parseFloat(l.total||0)>0);
  const taxa   = TAXAS[p.classe]||0;
  const desc   = p.emite_nfe ? (p.total||0)*taxa : 0;
  const totFin = (p.total||0) - desc;
  const bols   = (p.boletos||[]).filter((_,i)=>i<parseInt(p.qtd_boletos||0));
  const stilo = `
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&family=DM+Mono:wght@400;500&display=swap');
    *{box-sizing:border-box;margin:0;padding:0;}
    body{font-family:'DM Sans',sans-serif;background:#f8fafc;color:#1e293b;}
    .folha{max-width:800px;margin:0 auto;background:#fff;border:1px solid #e2e8f0;border-radius:12px;overflow:hidden;}
    .header{background:linear-gradient(135deg,#064e3b,#059669);color:#fff;padding:20px 24px;display:flex;justify-content:space-between;align-items:center;}
    .logo{font-size:28px;font-weight:900;letter-spacing:-1px;}
    .logo span{font-size:11px;display:block;font-weight:400;opacity:.8;letter-spacing:2px;text-transform:uppercase;margin-top:2px;}
    .ped-num{font-size:24px;font-weight:800;font-family:'DM Mono',monospace;}
    .body{padding:20px 24px;}
    .section{margin-bottom:16px;}
    .section-title{font-size:10px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:1.5px;margin-bottom:8px;padding-bottom:4px;border-bottom:1px solid #e2e8f0;}
    .grid2{display:grid;grid-template-columns:1fr 1fr;gap:12px;}
    .campo{display:flex;flex-direction:column;gap:2px;}
    .campo label{font-size:9px;color:#94a3b8;text-transform:uppercase;letter-spacing:1px;}
    .campo span{font-size:13px;font-weight:600;color:#1e293b;}
    table{width:100%;border-collapse:collapse;border:1px solid #e2e8f0;border-radius:8px;overflow:hidden;}
    thead th{background:#f1f5f9;padding:8px 10px;font-size:10px;text-align:left;color:#64748b;text-transform:uppercase;letter-spacing:1px;border-bottom:2px solid #cbd5e1;border-right:1px solid #e2e8f0;}
    thead th:last-child{border-right:none;}
    tbody td{padding:8px 10px;font-size:12px;border-bottom:1px solid #e2e8f0;border-right:1px solid #f1f5f9;}
    tbody td:last-child{border-right:none;}
    tbody tr:last-child td{border-bottom:none;}
    tfoot td{padding:8px 10px;font-size:13px;font-weight:700;}
    .total-row{background:#f8fafc;}
    .val{font-family:'DM Mono',monospace;}
    .badge{display:inline-block;padding:2px 8px;border-radius:4px;font-size:10px;font-weight:700;}
    .recorte{text-align:center;color:#94a3b8;font-size:11px;padding:12px;border-top:2px dashed #e2e8f0;border-bottom:2px dashed #e2e8f0;margin:16px 0;letter-spacing:2px;}
    .assinaturas{display:flex;justify-content:space-between;margin-top:24px;padding-top:12px;}
    .ass-linha{width:45%;border-top:1px solid #334155;padding-top:6px;text-align:center;font-size:11px;color:#64748b;}
    .pix-box{background:#f0fdf4;border:1px solid #a7f3d0;border-radius:8px;padding:10px 14px;font-size:12px;}
    .boleto-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));gap:8px;margin-top:8px;}
    .bol-card{background:#fffbeb;border:1px solid #fde68a;border-radius:8px;padding:10px 12px;font-size:12px;}
    .bol-num{font-weight:700;color:#92400e;font-size:11px;margin-bottom:4px;}
    .no-print{margin-bottom:16px;}
    @media print{
      .no-print{display:none!important;}
      body{background:#fff;}
      .folha{border:none;border-radius:0;max-width:100%;}
      *{-webkit-print-color-adjust:exact!important;print-color-adjust:exact!important;}
      table{border-collapse:collapse!important;width:100%!important;border:1px solid #94a3b8!important;}
      table th{border:1px solid #94a3b8!important;padding:6px 10px!important;background:#f1f5f9!important;}
      table td{border:1px solid #cbd5e1!important;padding:6px 10px!important;}
    }
  `;
  return (
    <div style={{minHeight:"100vh",background:"#f1f5f9",padding:"20px",fontFamily:"'DM Sans',sans-serif"}}>
      <style>{stilo}</style>
      <div className="no-print" style={{maxWidth:800,margin:"0 auto 16px",display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}}>
        <button onClick={onVoltar} style={{padding:"8px 18px",borderRadius:8,border:"1px solid #cbd5e1",background:"#fff",color:"#475569",cursor:"pointer",fontWeight:600,fontSize:13}}>← Voltar</button>
        <button onClick={()=>window.print()} style={{padding:"8px 22px",borderRadius:8,border:"none",background:"linear-gradient(135deg,#059669,#10b981)",color:"#fff",fontWeight:700,fontSize:13,cursor:"pointer",boxShadow:"0 2px 8px rgba(16,185,129,.3)"}}>🖨️ Imprimir</button>
        <div style={{fontSize:12,color:"#64748b",background:"#fffbeb",border:"1px solid #fde68a",borderRadius:8,padding:"6px 12px"}}>
          💡 No Chrome: ative <b>"Gráficos de fundo"</b> nas opções de impressão para ver as bordas
        </div>
      </div>
      <FolhaConteudo p={p} linhas={linhas} taxa={taxa} desc={desc} totFin={totFin} bols={bols}/>
      <div style={{maxWidth:800,margin:"0 auto"}}>
        <div className="recorte">✂ — — — — — — — — — — RECORTE AQUI — — — — — — — — — — ✂</div>
      </div>
      <FolhaConteudo p={p} linhas={linhas} taxa={taxa} desc={desc} totFin={totFin} bols={bols} via="2ª Via"/>
    </div>
  );
}

function FolhaConteudo({ p, linhas, taxa, desc, totFin, bols, via }) {
  return (
    <div className="folha" style={{maxWidth:800,margin:"0 auto 0"}}>
      <div className="header">
        <div>
          <div className="logo">🌿 GRANJA<span>CAVAZZINI</span></div>
          <div style={{fontSize:11,opacity:.8,marginTop:4}}>ALGACIR AUGUSTO CAVAZZINI</div>
          <div style={{fontSize:10,opacity:.7}}>CPF: 408.863.609-00 · Rod. MT 338, KM 12 - Tapurah/MT</div>
          <div style={{fontSize:10,opacity:.7}}>(66) 9 9637-8989 · contato@granjacavazzini.com.br</div>
        </div>
        <div style={{textAlign:"right"}}>
          <div style={{fontSize:10,opacity:.7,marginBottom:4}}>{via||"1ª Via"}</div>
          <div className="ped-num">Pedido #{p.pedido}</div>
          {p.nf && p.nf!=="0" && <div style={{fontSize:13,opacity:.9,marginTop:4}}>NF: {p.nf}</div>}
          <div style={{fontSize:12,opacity:.8,marginTop:4}}>{p.data} {p.hora && `· ${p.hora}`}</div>
          {p.mes && <div style={{fontSize:11,opacity:.7}}>{p.mes}</div>}
        </div>
      </div>
      <div className="body">
        <div className="section">
          <div className="section-title">👤 Dados do Cliente</div>
          <div className="grid2">
            <div className="campo"><label>Nome</label><span>{p.cliente}</span></div>
            <div className="campo"><label>CNPJ/CPF</label><span style={{fontFamily:"'DM Mono',monospace"}}>{p.cnpj||"—"}</span></div>
            <div className="campo"><label>Endereço</label><span>{p.endereco||"—"}</span></div>
            <div className="campo"><label>Cidade/UF</label><span>{p.cidade}/{p.uf}</span></div>
            <div className="campo"><label>Insc. Estadual</label><span>{p.ie||"—"}</span></div>
            <div className="campo"><label>Fone</label><span>{p.fone||"—"}</span></div>
          </div>
        </div>
        <div className="section">
          <div className="section-title">🌾 Produtos</div>
          <table>
            <thead>
              <tr><th>CX</th><th>Unid.</th><th>Descrição</th><th style={{textAlign:"right"}}>Vl. Unit.</th><th style={{textAlign:"right"}}>Total</th></tr>
            </thead>
            <tbody>
              {linhas.map((l,i)=>(
                <tr key={i}>
                  <td className="val">{l.cx||"—"}</td>
                  <td className="val">{l.qtde||"—"}</td>
                  <td style={{fontWeight:600}}>{l.nome}</td>
                  <td className="val" style={{textAlign:"right"}}>{fmtMoeda(parseFloat(String(l.vlUnit||"0").replace(",",".")))}</td>
                  <td className="val" style={{textAlign:"right",fontWeight:700}}>{fmtMoeda(l.total)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="total-row">
                <td colSpan={4} style={{textAlign:"right",color:"#64748b"}}>Valor Total:</td>
                <td className="val" style={{color:"#f59e0b"}}>{fmtMoeda(p.total)}</td>
              </tr>
              {p.emite_nfe && taxa>0 && <>
                <tr>
                  <td colSpan={4} style={{textAlign:"right",color:"#64748b",fontSize:11}}>Desc. Funrural ({(taxa*100).toFixed(2)}%):</td>
                  <td className="val" style={{color:"#ef4444",fontSize:11}}>- {fmtMoeda(desc)}</td>
                </tr>
                <tr style={{background:"#f0fdf4"}}>
                  <td colSpan={4} style={{textAlign:"right",fontWeight:800,fontSize:14}}>TOTAL COM DESCONTO:</td>
                  <td className="val" style={{color:"#059669",fontSize:15,fontWeight:800}}>{fmtMoeda(totFin)}</td>
                </tr>
              </>}
              {!p.emite_nfe && (
                <tr><td colSpan={5} style={{fontSize:11,color:"#94a3b8",fontStyle:"italic"}}>Desconto Funrural: Não aplicável</td></tr>
              )}
            </tfoot>
          </table>
        </div>
        <div className="section">
          <div className="section-title">💳 Condições de Pagamento</div>
          {p.tipo_pgto==="PIX" && (
            <div className="pix-box">
              <div style={{fontWeight:700,color:"#065f46",marginBottom:4}}>✅ Pagamento via PIX</div>
              <div>Chave PIX: <b>66-9 9995-6000</b></div>
              <div>Titular: <b>Algacir Augusto Cavazzini</b></div>
              <div style={{marginTop:4,fontFamily:"'DM Mono',monospace",fontSize:14,fontWeight:800,color:"#065f46"}}>{fmtMoeda(p.total)}</div>
            </div>
          )}
          {p.tipo_pgto==="À VISTA" && (
            <div style={{background:"#eff6ff",border:"1px solid #bfdbfe",borderRadius:8,padding:"10px 14px",fontSize:13}}>
              <b>À Vista</b> — {fmtMoeda(p.total)}
            </div>
          )}
          {p.tipo_pgto==="BOLETO" && bols.length>0 && (
            <div>
              <div style={{fontSize:12,color:"#64748b",marginBottom:6}}>
                Boletos emitidos pelo <b>SICOOB</b> · {bols.length}x · Base: {fmtMoeda(p.emite_nfe&&totFin>0?totFin:p.total)}
              </div>
              <div className="boleto-grid">
                {bols.map((b,i)=>(
                  <div key={i} className="bol-card">
                    <div className="bol-num">Boleto {i+1}</div>
                    <div>Dias: <b>{b.dias||"—"}</b></div>
                    <div>Vcto: <b>{b.dias?addDias(b.dias):"—"}</b></div>
                    <div style={{fontFamily:"'DM Mono',monospace",fontWeight:800,color:"#92400e",marginTop:4,fontSize:13}}>
                      {fmtMoeda((p.emite_nfe&&totFin>0?totFin:p.total)/bols.length)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {!p.tipo_pgto && <div style={{fontSize:12,color:"#94a3b8"}}>Não informado</div>}
        </div>
        <div className="assinaturas">
          <div className="ass-linha">Assinatura da Granja</div>
          <div className="ass-linha">Assinatura do Cliente</div>
        </div>
      </div>
    </div>
  );
}

function TelaForm({ form, setForm, clientes, produtos, onSalvar, onVoltar, onDel, onImprimir }) {
  const f = form || formVazio();
  const up = (k,v) => setForm(prev=>({...prev,[k]:v}));
  const isNovo = !f.id;
  const totalGeral  = f.linhas.reduce((a,l)=>a+(l.total||0),0);
  const taxa        = TAXAS[f.classe]||0;
  const desconto    = f.emiteNfe ? totalGeral*taxa : 0;
  const totalFinal  = totalGeral - desconto;
  const baseCalculo = f.emiteNfe && totalFinal>0 ? totalFinal : totalGeral;
  return (
    <div className="fade" style={{display:"flex",flexDirection:"column",gap:16}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:10}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <button onClick={onVoltar} style={{padding:"7px 13px",borderRadius:8,border:"1px solid #1e3a5f",background:"transparent",color:"#60a5fa",cursor:"pointer",fontSize:13}}>← Voltar</button>
          <div style={{fontSize:16,fontWeight:800,color:"#f1f5f9"}}>{isNovo?"Novo Pedido":`Editando Pedido #${f.pedido}`}</div>
        </div>
        <div style={{display:"flex",gap:8}}>
          {!isNovo && <button onClick={()=>onImprimir(f)} style={{padding:"8px 14px",borderRadius:8,border:"1px solid #4c1d95",background:"rgba(139,92,246,.1)",color:"#a78bfa",cursor:"pointer",fontSize:13,fontWeight:600}}>🖨️ Imprimir</button>}
          {!isNovo && <button onClick={()=>onDel(f.id)} style={{padding:"8px 14px",borderRadius:8,border:"1px solid #3f1515",background:"rgba(239,68,68,.07)",color:"#f87171",cursor:"pointer",fontSize:13,fontWeight:600}}>🗑️ Excluir</button>}
          <button onClick={()=>onSalvar(f)} style={{padding:"8px 22px",borderRadius:8,border:"none",background:"linear-gradient(135deg,#059669,#10b981)",color:"#fff",fontWeight:700,fontSize:14,cursor:"pointer",boxShadow:"0 3px 14px rgba(16,185,129,.3)"}}>
            💾 {isNovo?"Salvar Pedido":"Salvar Alterações"}
          </button>
        </div>
      </div>
      <Sec title="📋 Identificação">
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(120px,1fr))",gap:11}}>
          <FI label="Nº Pedido" value={f.pedido} onChange={v=>up("pedido",v)} placeholder="000123"/>
          <FI label="NF"        value={f.nf}     onChange={v=>up("nf",v)}     placeholder="000456"/>
          <FI label="Data"      value={f.data}   onChange={v=>{up("data",v);try{up("mes",MESES[new Date(v.split("/").reverse().join("-")).getMonth()])}catch{}}} placeholder="dd/mm/aaaa"/>
          <FI label="Mês"       value={f.mes}    disabled/>
          <FI label="Hora"      value={f.hora}   disabled/>
        </div>
      </Sec>
      <Sec title="👤 Cliente">
        <ClienteAC value={f.cliente} clientes={clientes} onSelect={c=>{up("cliente",c.nome);up("endereco",c.endereco);up("cidade",c.cidade);up("uf",c.uf);up("fone",c.fone);up("cnpj",c.cnpj);up("ie",c.ie);up("classe",c.classe);}} onChange={v=>up("cliente",v)}/>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:11,marginTop:11}}>
          <FI label="Endereço" value={f.endereco} onChange={v=>up("endereco",v)}/>
          <FI label="Cidade"   value={f.cidade}   onChange={v=>up("cidade",v)}/>
          <FI label="UF"       value={f.uf}       onChange={v=>up("uf",v.toUpperCase().slice(0,2))} placeholder="MT"/>
          <FI label="Fone"     value={f.fone}     onChange={v=>up("fone",v)}/>
          <FI label="CNPJ/CPF" value={f.cnpj}     onChange={v=>up("cnpj",v)}/>
          <FI label="IE"       value={f.ie}       onChange={v=>up("ie",v)}/>
          <FS label="Classe"   value={f.classe}   onChange={v=>up("classe",v)} opts={["CNPJ","CPF"]}/>
        </div>
      </Sec>
      <Sec title="🌾 Produtos">
        <ProdGrid linhas={f.linhas} produtos={produtos} onChange={ls=>up("linhas",ls)}/>
        <div style={{display:"flex",justifyContent:"flex-end",alignItems:"center",gap:10,marginTop:12}}>
          <span style={{fontSize:12,color:"#475569"}}>Total Geral:</span>
          <span style={{fontSize:21,fontWeight:800,color:"#f59e0b",fontFamily:"'DM Mono',monospace"}}>{fmtMoeda(totalGeral)}</span>
        </div>
      </Sec>
      <Sec title="🧾 NF-e & Funrural">
        <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",marginBottom:12}}>
          <input type="checkbox" checked={f.emiteNfe} onChange={e=>up("emiteNfe",e.target.checked)} style={{width:15,height:15,accentColor:"#10b981",cursor:"pointer"}}/>
          <span style={{fontWeight:600,fontSize:14,color:"#e2e8f0"}}>Emite NF-e</span>
          {f.classe && <Chip c={f.classe==="CNPJ"?"blue":"amber"}>{f.classe}</Chip>}
        </label>
        {f.emiteNfe && totalGeral>0 && taxa>0 && (
          <div style={{background:"rgba(16,185,129,.045)",border:"1px solid rgba(16,185,129,.16)",borderRadius:9,padding:14,display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))",gap:12}}>
            <StatB label="Taxa Funrural" value={`${(taxa*100).toFixed(2)}%`}/>
            <StatB label="Valor Total"   value={fmtMoeda(totalGeral)}/>
            <StatB label="Desconto"      value={fmtMoeda(desconto)}   color="#f87171"/>
            <StatB label="Total Final"   value={fmtMoeda(totalFinal)} color="#34d399" big/>
          </div>
        )}
      </Sec>
      <Sec title="💳 Pagamento">
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:11,marginBottom:14}}>
          <FS label="Tipo" value={f.tipoPgto} onChange={v=>up("tipoPgto",v)} opts={["PIX","À VISTA","BOLETO"]}/>
          {f.tipoPgto==="BOLETO" && <FS label="Qtde Boletos" value={f.qtdeBol} onChange={v=>up("qtdeBol",v)} opts={["1","2","3"]}/>}
        </div>
        {f.tipoPgto==="BOLETO" && parseInt(f.qtdeBol)>0 && (
          <BoletoGrid boletos={f.boletos} qtde={parseInt(f.qtdeBol)} base={baseCalculo} onChange={bs=>up("boletos",bs)}/>
        )}
      </Sec>
      <div style={{display:"flex",justifyContent:"flex-end",gap:10,paddingBottom:12}}>
        <button onClick={onVoltar} style={{padding:"9px 20px",borderRadius:8,border:"1px solid #1e3a5f",background:"transparent",color:"#475569",cursor:"pointer",fontWeight:600,fontSize:13}}>Cancelar</button>
        <button onClick={()=>onSalvar(f)} style={{padding:"9px 28px",borderRadius:8,border:"none",background:"linear-gradient(135deg,#059669,#10b981)",color:"#fff",fontWeight:700,fontSize:14,cursor:"pointer",boxShadow:"0 3px 16px rgba(16,185,129,.3)"}}>
          💾 {isNovo?"Salvar Pedido":"Salvar Alterações"}
        </button>
      </div>
    </div>
  );
}

function ClienteAC({ value, clientes, onSelect, onChange }) {
  const [open, setOpen] = useState(false);
  const [lista, setLista] = useState([]);
  const ref = useRef();
  useEffect(() => {
    const fn = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", fn);
    return () => document.removeEventListener("mousedown", fn);
  }, []);
  const handle = v => {
    onChange(v);
    const r = v.trim().length>0 ? clientes.filter(c=>c.nome.toLowerCase().includes(v.toLowerCase())) : clientes;
    setLista(r); setOpen(r.length>0);
  };
  return (
    <div ref={ref} style={{position:"relative"}}>
      <label style={{fontSize:9,fontWeight:600,color:"#475569",textTransform:"uppercase",letterSpacing:"1.2px",display:"block",marginBottom:4}}>Cliente</label>
      <input value={value||""} onChange={e=>handle(e.target.value)}
        onFocus={e=>{e.target.style.borderColor="#10b981";handle(value);}}
        onBlur={e=>e.target.style.borderColor="#1e3a5f"}
        placeholder="Digite o nome do cliente..."
        style={{width:"100%",background:"#1a2840",border:"1px solid #1e3a5f",borderRadius:8,padding:"9px 12px",color:"#e2e8f0",fontSize:13,outline:"none",transition:"border .15s"}}/>
      {open && lista.length>0 && (
        <div style={{position:"absolute",top:"calc(100% + 4px)",left:0,right:0,background:"#0f1a2e",border:"1px solid #1e3a5f",borderRadius:10,zIndex:999,maxHeight:210,overflowY:"auto",boxShadow:"0 12px 40px rgba(0,0,0,.7)"}}>
          {lista.map(c=>(
            <div key={c.id} onMouseDown={e=>{e.preventDefault();onSelect(c);setOpen(false);}}
              style={{padding:"9px 13px",cursor:"pointer",borderBottom:"1px solid rgba(255,255,255,.04)"}}
              onMouseOver={e=>e.currentTarget.style.background="rgba(52,211,153,.1)"}
              onMouseOut={e=>e.currentTarget.style.background="transparent"}>
              <div style={{fontSize:13,fontWeight:600,color:"#e2e8f0"}}>{c.nome}</div>
              <div style={{fontSize:10,color:"#334155",marginTop:2}}>{c.cidade}/{c.uf} · {c.classe} · {c.cnpj}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function ProdGrid({ linhas, produtos, onChange }) {
  const [dd, setDd] = useState(-1);
  const refs = useRef([]);
  useEffect(() => {
    const fn = e => { if (dd>=0 && refs.current[dd] && !refs.current[dd].contains(e.target)) setDd(-1); };
    document.addEventListener("mousedown", fn);
    return () => document.removeEventListener("mousedown", fn);
  }, [dd]);
  const upd = (i, campo, val) => {
    const novas = linhas.map((l,idx) => {
      if (idx!==i) return l;
      const n = {...l,[campo]:val};
      if (campo==="nome") { const p=produtos.find(p=>p.nome===val); n.cxBase=p?.cx||0; n.cx=""; n.total=0; }
      const q  = parseFloat(campo==="qtde"  ?val:n.qtde)||0;
      const vu = parseFloat(String(campo==="vlUnit"?val:n.vlUnit).replace(",","."))||0;
      n.total = q*vu;
      if (n.cxBase>0 && q>0) n.cx=String(Math.round(q/n.cxBase));
      return n;
    });
    onChange(novas);
  };
  const inS={width:"100%",background:"#1a2840",border:"1px solid #1e3a5f",borderRadius:7,padding:"7px 8px",color:"#e2e8f0",fontSize:12,outline:"none"};
  const diS={...inS,background:"#0d1526",color:"#1e3a5f",border:"1px solid #0f1e35"};
  return (
    <div style={{overflowX:"auto"}}>
      <table style={{width:"100%",borderCollapse:"collapse",minWidth:560}}>
        <thead>
          <tr style={{borderBottom:"1px solid rgba(52,211,153,.08)"}}>
            {["#","Produto","Qtde","CX","Vl. Unit.","Total"].map(h=>(
              <th key={h} style={{padding:"6px 7px",textAlign:"left",fontSize:9,color:"#334155",textTransform:"uppercase",letterSpacing:"1.2px"}}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {linhas.map((l,i)=>(
            <tr key={i} style={{borderBottom:"1px solid rgba(255,255,255,.03)"}}>
              <td style={{padding:"5px 7px",color:"#1e3a5f",fontSize:11,width:20}}>{i+1}</td>
              <td style={{padding:"5px 7px",position:"relative",minWidth:195}} ref={el=>refs.current[i]=el}>
                <input value={l.nome||""} onChange={e=>upd(i,"nome",e.target.value)} onFocus={()=>setDd(i)} placeholder="Selecione..." style={inS}/>
                {dd===i && (
                  <div style={{position:"absolute",top:"100%",left:0,right:0,background:"#0f1a2e",border:"1px solid #1e3a5f",borderRadius:9,zIndex:800,maxHeight:165,overflowY:"auto",boxShadow:"0 8px 28px rgba(0,0,0,.65)",marginTop:2}}>
                    {produtos.filter(p=>!l.nome||p.nome.toLowerCase().includes(l.nome.toLowerCase())).map(p=>(
                      <div key={p.id} onMouseDown={e=>{e.preventDefault();upd(i,"nome",p.nome);setDd(-1);}}
                        style={{padding:"7px 11px",cursor:"pointer",fontSize:12,color:"#e2e8f0",borderBottom:"1px solid rgba(255,255,255,.03)"}}
                        onMouseOver={e=>e.currentTarget.style.background="rgba(52,211,153,.09)"}
                        onMouseOut={e=>e.currentTarget.style.background="transparent"}>
                        {p.nome} <span style={{color:"#1e3a5f",fontSize:10}}>CX:{p.cx}</span>
                      </div>
                    ))}
                  </div>
                )}
              </td>
              <td style={{padding:"5px 7px",width:65}}><input value={l.qtde||""} onChange={e=>upd(i,"qtde",e.target.value)} placeholder="0" style={{...inS,textAlign:"center"}}/></td>
              <td style={{padding:"5px 7px",width:50}}><input value={l.cx||""} disabled style={{...diS,textAlign:"center"}}/></td>
              <td style={{padding:"5px 7px",width:95}}><input value={l.vlUnit||""} onChange={e=>upd(i,"vlUnit",e.target.value)} placeholder="0,00" style={{...inS,textAlign:"right"}}/></td>
              <td style={{padding:"5px 7px",width:105}}><input value={l.total?fmtMoeda(l.total):""} disabled style={{...diS,textAlign:"right",color:"#f59e0b",fontWeight:700}}/></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function BoletoGrid({ boletos, qtde, base, onChange }) {
  const upd = (i,dias) => onChange(boletos.map((b,idx)=>idx===i?{...b,dias}:b));
  return (
    <div style={{background:"rgba(245,158,11,.04)",border:"1px solid rgba(245,158,11,.15)",borderRadius:9,padding:14}}>
      <div style={{fontSize:10,color:"#f59e0b",fontWeight:700,textTransform:"uppercase",letterSpacing:"1.2px",marginBottom:12}}>📄 Boletos — Base: {fmtMoeda(base)}</div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:11}}>
        {Array.from({length:qtde},(_,i)=>(
          <div key={i} style={{background:"rgba(0,0,0,.18)",border:"1px solid rgba(245,158,11,.1)",borderRadius:8,padding:12}}>
            <div style={{fontSize:11,fontWeight:700,color:"#f59e0b",marginBottom:9}}>Boleto {i+1}</div>
            <FI label="Dias p/ vencimento" value={boletos[i]?.dias||""} onChange={v=>upd(i,v)} placeholder="30"/>
            {boletos[i]?.dias && (
              <div style={{marginTop:9,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span style={{fontSize:11,color:"#64748b"}}>Vcto: <b style={{color:"#f59e0b"}}>{addDias(boletos[i].dias)}</b></span>
                <span style={{fontSize:13,fontWeight:800,color:"#34d399",fontFamily:"'DM Mono',monospace"}}>{fmtMoeda(base/qtde)}</span>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

function TelaCadastro({ tipo, itens, onSalvar, onDel }) {
  const isC = tipo==="clientes";
  const [ed, setEd] = useState(null);
  const [busca, setBusca] = useState("");
  const [salvando, setSalvando] = useState(false);
  const vz = isC ? {nome:"",endereco:"",cidade:"",uf:"",fone:"",cnpj:"",ie:"",classe:"CNPJ"} : {nome:"",cx:""};
  const lista = itens.filter(it=>it.nome.toLowerCase().includes(busca.toLowerCase()));
  const handleSalvar = async item => {
    if (!item.nome.trim()) return;
    setSalvando(true); await onSalvar(item); setSalvando(false); setEd(null);
  };
  return (
    <div className="fade">
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16,flexWrap:"wrap",gap:10}}>
        <div style={{fontSize:17,fontWeight:800,color:"#f1f5f9"}}>{isC?"👤 Clientes":"🌾 Produtos"} <span style={{fontSize:13,color:"#334155",fontWeight:400}}>({itens.length})</span></div>
        <div style={{display:"flex",gap:10,alignItems:"center"}}>
          <div style={{position:"relative"}}>
            <span style={{position:"absolute",left:9,top:"50%",transform:"translateY(-50%)",color:"#334155"}}>🔍</span>
            <input value={busca} onChange={e=>setBusca(e.target.value)} placeholder="Buscar..." style={{background:"#0d1526",border:"1px solid #1e3a5f",borderRadius:8,padding:"8px 11px 8px 30px",color:"#e2e8f0",fontSize:13,outline:"none",width:180}}/>
          </div>
          <button onClick={()=>setEd({...vz})} style={{padding:"8px 16px",borderRadius:8,border:"none",background:"linear-gradient(135deg,#059669,#10b981)",color:"#fff",fontWeight:700,fontSize:13,cursor:"pointer"}}>
            + {isC?"Novo Cliente":"Novo Produto"}
          </button>
        </div>
      </div>
      {ed && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.78)",zIndex:7000,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
          <div className="fade" style={{background:"#0f1a2e",border:"1px solid #1e3a5f",borderRadius:14,padding:22,width:"100%",maxWidth:500}}>
            <div style={{fontSize:15,fontWeight:700,color:"#f1f5f9",marginBottom:14}}>{isC?"Cliente":"Produto"}</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(150px,1fr))",gap:11}}>
              <div style={{gridColumn:"1/-1"}}><FI label="Nome" value={ed.nome||""} onChange={v=>setEd(e=>({...e,nome:v}))}/></div>
              {isC ? <>
                <FI label="Endereço" value={ed.endereco||""} onChange={v=>setEd(e=>({...e,endereco:v}))}/>
                <FI label="Cidade"   value={ed.cidade||""}   onChange={v=>setEd(e=>({...e,cidade:v}))}/>
                <FI label="UF"       value={ed.uf||""}       onChange={v=>setEd(e=>({...e,uf:v.toUpperCase().slice(0,2)}))} placeholder="MT"/>
                <FI label="Fone"     value={ed.fone||""}     onChange={v=>setEd(e=>({...e,fone:v}))}/>
                <FI label="CNPJ/CPF" value={ed.cnpj||""}     onChange={v=>setEd(e=>({...e,cnpj:v}))}/>
                <FI label="IE"       value={ed.ie||""}       onChange={v=>setEd(e=>({...e,ie:v}))}/>
                <FS label="Classe"   value={ed.classe||"CNPJ"} onChange={v=>setEd(e=>({...e,classe:v}))} opts={["CNPJ","CPF"]}/>
              </> : <>
                <FI label="CX (un/caixa)" value={String(ed.cx||"")} onChange={v=>setEd(e=>({...e,cx:v}))} placeholder="40"/>
              </>}
            </div>
            <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:16}}>
              <button onClick={()=>setEd(null)} style={{padding:"8px 18px",borderRadius:8,border:"1px solid #1e3a5f",background:"transparent",color:"#475569",cursor:"pointer",fontWeight:600}}>Cancelar</button>
              <button onClick={()=>handleSalvar(ed)} disabled={salvando} style={{padding:"8px 20px",borderRadius:8,border:"none",background:"linear-gradient(135deg,#059669,#10b981)",color:"#fff",fontWeight:700,cursor:"pointer",opacity:salvando?0.6:1}}>
                {salvando?"Salvando...":"Salvar"}
              </button>
            </div>
          </div>
        </div>
      )}
      <div style={{background:"#0d1526",border:"1px solid rgba(52,211,153,.09)",borderRadius:11,overflow:"hidden"}}>
        <table style={{width:"100%",borderCollapse:"collapse"}}>
          <thead>
            <tr style={{borderBottom:"1px solid rgba(52,211,153,.09)",background:"rgba(52,211,153,.025)"}}>
              {(isC?["Nome","Cidade/UF","CNPJ/CPF","Classe","Fone",""]:["Nome","CX",""]).map(h=>(
                <th key={h} style={{padding:"10px 13px",textAlign:"left",fontSize:9,color:"#334155",textTransform:"uppercase",letterSpacing:"1.2px"}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {lista.length===0
              ? <tr><td colSpan={6} style={{padding:36,textAlign:"center",color:"#1e3a5f",fontSize:13}}>Nenhum item encontrado.</td></tr>
              : lista.map((it,i)=>(
                <tr key={it.id} style={{borderBottom:"1px solid rgba(255,255,255,.04)",background:i%2?"rgba(255,255,255,.01)":"transparent"}}>
                  {isC ? <>
                    <td style={{padding:"10px 13px",fontSize:13,color:"#e2e8f0",fontWeight:500}}>{it.nome}</td>
                    <td style={{padding:"10px 13px",fontSize:11,color:"#475569"}}>{it.cidade}/{it.uf}</td>
                    <td style={{padding:"10px 13px",fontSize:11,color:"#334155",fontFamily:"'DM Mono',monospace"}}>{it.cnpj}</td>
                    <td style={{padding:"10px 13px"}}><Chip c={it.classe==="CNPJ"?"blue":"amber"}>{it.classe||"—"}</Chip></td>
                    <td style={{padding:"10px 13px",fontSize:11,color:"#334155"}}>{it.fone}</td>
                  </> : <>
                    <td style={{padding:"10px 13px",fontSize:13,color:"#e2e8f0",fontWeight:500}}>{it.nome}</td>
                    <td style={{padding:"10px 13px",fontSize:13,color:"#34d399",fontFamily:"'DM Mono',monospace",fontWeight:700}}>{it.cx}</td>
                  </>}
                  <td style={{padding:"10px 13px"}}>
                    <div style={{display:"flex",gap:4}}>
                      <button className="ibtn" style={{borderColor:"#60a5fa22",color:"#60a5fa"}} onClick={()=>setEd({...it})}>✏️</button>
                      <button className="ibtn" style={{borderColor:"#f8717122",color:"#f87171"}} onClick={()=>onDel(it.id)}>🗑️</button>
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ── Componentes utilitários ───────────────────────────────────
function Sec({ title, children }) {
  return (
    <div style={{background:"#0d1526",border:"1px solid rgba(52,211,153,.09)",borderRadius:11,overflow:"hidden"}}>
      <div style={{padding:"10px 16px",borderBottom:"1px solid rgba(52,211,153,.06)",background:"rgba(52,211,153,.02)"}}>
        <span style={{fontSize:12,fontWeight:700,color:"#475569"}}>{title}</span>
      </div>
      <div style={{padding:16}}>{children}</div>
    </div>
  );
}
function FI({ label, value, onChange, disabled, placeholder }) {
  return (
    <div style={{display:"flex",flexDirection:"column",gap:3}}>
      {label && <label style={{fontSize:9,fontWeight:600,color:"#475569",textTransform:"uppercase",letterSpacing:"1.2px"}}>{label}</label>}
      <input value={value||""} onChange={e=>onChange&&onChange(e.target.value)} disabled={disabled} placeholder={placeholder}
        style={{background:disabled?"#0d1526":"#1a2840",border:`1px solid ${disabled?"#0f1e35":"#1e3a5f"}`,borderRadius:7,padding:"8px 10px",color:disabled?"#1e3a5f":"#e2e8f0",fontSize:12,outline:"none",transition:"border .15s"}}
        onFocus={e=>!disabled&&(e.target.style.borderColor="#10b981")}
        onBlur={e=>(e.target.style.borderColor=disabled?"#0f1e35":"#1e3a5f")}/>
    </div>
  );
}
function FS({ label, value, onChange, opts }) {
  return (
    <div style={{display:"flex",flexDirection:"column",gap:3}}>
      {label && <label style={{fontSize:9,fontWeight:600,color:"#475569",textTransform:"uppercase",letterSpacing:"1.2px"}}>{label}</label>}
      <select value={value||""} onChange={e=>onChange(e.target.value)} style={{background:"#1a2840",border:"1px solid #1e3a5f",borderRadius:7,padding:"8px 10px",color:"#e2e8f0",fontSize:12,outline:"none"}}>
        <option value="">Selecione...</option>
        {opts.map(o=><option key={o} value={o}>{o}</option>)}
      </select>
    </div>
  );
}
function Chip({ children, c="green" }) {
  const m={green:["#0a2318","#10b981"],blue:["#0a1628","#60a5fa"],amber:["#1f1408","#f59e0b"],red:["#200a0a","#f87171"]};
  const [bg,fg]=(m[c]||m.green);
  return <span style={{background:bg,color:fg,border:`1px solid ${fg}30`,padding:"2px 8px",borderRadius:5,fontSize:10,fontWeight:700,whiteSpace:"nowrap"}}>{children}</span>;
}
function StatB({ label, value, color="#64748b", big }) {
  return (
    <div>
      <div style={{fontSize:9,color:"#334155",textTransform:"uppercase",letterSpacing:"1.2px",marginBottom:3}}>{label}</div>
      <div style={{fontSize:big?17:13,fontWeight:big?800:600,color,fontFamily:"'DM Mono',monospace"}}>{value}</div>
    </div>
  );
}
